<template>
  <div class="card-landscape profile">
    <!-- Помощь по пункту «Пути новичка»: игрок нажал пункт в профиле — показываем, что нажать -->
    <TutorialHelp route="/profile" />
    <div class="profile__face">
      <div class="profile__photo">
        <img v-if="profile.avatar" :src="profile.avatar" alt="">
        <img v-else :src='thumb' alt="">
      </div>
      <div class="profile__username">
        {{ profile.username }}
      </div>
      <!-- «Выйти» стоит между ником и кошельком (решение оунера 2026-07-30): выход — про аккаунт,
           а не про разделы игры. Оформление — та же табличка на цепях, что у ника и кошелька,
           чтобы шапка читалась одним блоком, а не «ник + чужая оранжевая кнопка». -->
      <button class="profile__logout-top" @click="logout">
        {{ $t('profile.logout') }}
      </button>
      <!-- Смена пароля (волна 5.2): рядом с «Выйти» — оба про аккаунт, а не про разделы игры.
           После успеха сервер отдаёт свежий токен: все прежние сессии игрока (включая турнирные)
           перестают работать, а этот клиент продолжает играть без повторного входа. -->
      <button class="profile__logout-top" @click="openPwd">
        {{ $t('profile.changePassword') }}
      </button>
      <!-- Кошелёк TON (web3 Э1). 🔴 Блок ДЕРЖИТ СВОЁ МЕСТО с первого кадра: состояние приезжает
           отдельным запросом, и без каркаса шапка профиля прыгала бы после ответа. Пока не знаем
           ответа — показываем прежнюю надпись, а не пустоту. -->
      <button
        class="profile__wallet" :class="{ 'profile__wallet--linked': tonLinked }"
        :disabled="tonBusy" @click="onWallet"
      >
        <span v-if="tonBusy">{{ $t('profile.walletWait') }}</span>
        <span v-else-if="tonLinked">{{ tonShort }}</span>
        <span v-else>{{ $t('profile.connectWallet') }}</span>
      </button>
      <!-- 🔴 TELEGRAM — В ШАПКЕ, А НЕ В РЯДУ РАЗДЕЛОВ (просьба оунера 2026-08-23: «периодически нажимаю
           его по ошибке»). Кнопка стояла последней среди «Колесо / Рынок / Задания / Настройки фигур»
           и ловила промахи мимо «Настроек фигур», а отвязка Telegram — операция про АККАУНТ, как
           «Выйти» и «Сменить пароль». Здесь же она рядом с кошельком: обе привязки в одном месте.
           Вид — та же табличка на цепях, что у соседей, с иконкой ✈ вместо слова «Telegram». -->
      <button v-if="tgAvailable && !tgLinked" class="profile__logout-top" :disabled="tgBusy" @click="linkTelegram">
        {{ $t('profile.tgLink') }}
      </button>
      <!-- 🔴 ПУТЬ ДЛЯ ИГРОКА СО СТАРЫМ АККАУНТОМ (2026-08-14). Первый запуск мини-аппа входит сразу и
           заводит НОВЫЙ аккаунт — кнопки «Привязать» игрок уже не видит (этот аккаунт привязан), и
           дороги к своему прогрессу не было вовсе. Кнопка выводит на форму входа и запоминает, что
           после входа логином и паролем Telegram надо привязать автоматически. -->
      <button v-if="tgAvailable && tgLinked" class="profile__logout-top" @click="switchToOwnAccount">
        {{ $t('profile.tgSwitch') }}
      </button>
      <!-- 🔴 ПРИВЯЗКА С ОБЫЧНОГО САЙТА — ТОЛЬКО ЧЕРЕЗ МИНИ-ПРИЛОЖЕНИЕ (решение оунера 2026-08-18).
           Раньше здесь была кнопка Telegram Login Widget, но её рисует САМ Telegram, и у игроков она
           часто не появлялась вовсе (нет `/setdomain` у бота, другое написание домена, блокировщик).
           Ссылка в мини-апп делает ровно то же самое — открывает Telegram игрока — и ни от чего этого
           не зависит, поэтому виджет убран, путь остался один. -->
      <!-- 🔴 МЕСТО ПОД КНОПКУ ЗАНЯТО С ПЕРВОГО КАДРА (жалоба оунера 2026-08-31: «кнопки появляются с
           задержкой, из-за этого окно раздела расширяется»). Признак `code_link` приезжает
           ОТДЕЛЬНЫМ запросом `/users/telegram/config`, и до ответа кнопки не было вовсе: её приход
           добавлял шапке целую строку, а шапка — ячейка сетки, поэтому вместе с ней растягивалась
           «Статистика» и уезжало всё, что ниже. Пока ответа нет — рисуем ту же кнопку невидимой. -->
      <button
        v-if="!tgAvailable && !tgLinked && (tgCodeLink || tgCfgPending)"
        class="profile__logout-top" :class="{ 'profile__logout-top--pending': !tgCodeLink }"
        @click="openTgLink"
      >
        {{ $t('profile.tgLink') }}
      </button>
      <!-- Отвязать: нужен, когда игрок хочет перевесить Telegram на другой свой аккаунт (например,
           поиграл телеграм-аккаунтом, а вернуться хочет в старый). -->
      <button
        v-if="tgLinked && !tgAvailable" class="profile__logout-top profile__logout-top--muted"
        :disabled="tgBusy" @click="unlinkTelegram"
      >
        {{ $t('profile.tgUnlink') }}
      </button>
    </div>
    <div class="profile__rating">
      <span class="profile__box-label">{{ $t('common.rating') }}</span>
      <span class="profile__box-val">{{ ratingDisplay }}</span>
    </div>
    <div class="profile__energy">
      <span class="profile__box-label">{{ $t('common.energy') }}</span>
      <span class="profile__box-val">{{ energyDisplay }}</span>
    </div>
    <!-- Ресурсы: КАЖДЫЙ кошелёк в своей рамке — самоцветы, материалы, бусты (решение оунера 2026-07-30).
         🔴 ЧИПЫ СТОЯТ С ПЕРВОГО КАДРА (фидбек оунера 2026-08-10 «на ПК ресурсы появляются после всех
         кнопок»): каркас-то был, но содержимое пряталось за `v-if` — блок оставался пустым и панель
         возникала последней. Теперь ячейки на местах сразу, до ответа просто приглушены и без чисел. -->
    <div class="profile__resources" :class="{ 'profile__resources--pending': !resources }">
      <div class="pf__res-group pf__res-group--gems">
        <div
          v-for="g in GEMS" :key="g.key"
          class="pf__res-chip pf__res-chip--gem" :title="$t('profile.gemHint', { name: g.label })"
          @click="toggleGem(g.key)"
          @mouseenter="hoverGem = g.key"
          @mouseleave="hoverGem = null"
        >
          <span class="pf__gem" :style="{ background: g.color }"></span>
          <span class="pf__res-val">{{ gemTotal(g.key) }}</span>
          <div v-if="gemPopupOpen(g.key)" class="pf__gem-pop" @click.stop>
            <div class="pf__gem-pop-title">{{ $t('profile.gemBySize', { name: g.label }) }}</div>
            <div
              v-for="b in gemBreakdown(g.key)" :key="b.key"
              class="pf__gem-row" :class="{ 'pf__gem-row--has': b.count > 0 }"
            >
              <span class="pf__gem-sm" :style="{ background: g.color }"></span>
              <span class="pf__gem-size">{{ b.label }}</span>
              <span class="pf__gem-cnt">{{ b.count }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="pf__res-group pf__res-group--mat">
        <div
          v-for="m in MATERIALS" :key="m.key"
          class="pf__res-chip pf__res-chip--mat" :title="m.label"
        >
          <span class="pf__res-ico">{{ m.icon }}</span>
          <span class="pf__res-val">{{ resVal(m.key) }}</span>
        </div>
      </div>
      <!-- БУСТЫ (пески времени, свитки, эфир, молот) — их не было видно в профиле вовсе -->
      <div class="pf__res-group pf__res-group--boost">
        <div
          v-for="c in BOOSTS" :key="c.key"
          class="pf__res-chip pf__res-chip--mat" :title="c.label"
        >
          <span class="pf__res-ico">{{ c.icon }}</span>
          <span class="pf__res-val">{{ resVal(c.key) }}</span>
        </div>
      </div>
    </div>
    <div class="profile__statistic">
      <div class="profile__statistic__title">
        {{ $t('profile.statistic') }}
      </div>
      <div>
        {{ $t('profile.totalGames') }}: {{ profile.wins + profile.loses }}
      </div>
      <div>
        {{ $t('profile.wins') }}: {{ profile.wins }}
      </div>
      <div>
        {{ $t('profile.loses') }}: {{ profile.loses }}
      </div>
      <div>
        {{ $t('profile.energyTotal') }}: {{ profile.energy }}
      </div>
      <!-- 🔴 Блок рисуется ВСЕГДА и лишь прячется до ответа `/users/referral` (`visibility: hidden`):
           при `v-if` его появление удлиняло карточку статистики, и ряд кнопок под ней подпрыгивал уже
           после того, как игрок навёл курсор. Скрытый блок занимает ТУ ЖЕ высоту — резерв точен. -->
      <div class="profile__referral" :class="{ 'profile__referral--pending': !referral }">
        <div class="profile__referral-title">{{ $t('profile.referralTitle') }}</div>
        <div class="profile__referral-row">
          <input class="profile__referral-link" :value="referralLink" readonly @focus="$event.target.select()">
          <button class="profile__referral-copy" @click="copyReferral">
            {{ copied ? '✓' : $t('profile.copy') }}
          </button>
        </div>
        <!-- 🔴 ЧТО ИМЕННО ДАЁТ ПРИГЛАШЕНИЕ — СЛОВАМИ (просьба оунера 2026-09-11: «сделать раздел с
             рефералкой более заметным, сейчас многие его не могут найти»). Ссылку без обещания
             награды не копируют: раньше блок был безымянной строкой под статистикой. Числа те же,
             что в `apps/user/referral.py` — 5 билетов новичку и до 5 пригласившему. -->
        <div class="profile__referral-why">{{ $t('profile.referralWhy') }}</div>
        <div class="profile__referral-stats">
          {{ $t('profile.invited') }}: <b>{{ (referral || {}).invited || 0 }}</b> · {{ $t('common.tickets') }}: <b>{{ (referral || {}).tickets || 0 }}</b>
        </div>
      </div>
    </div>
    <!-- Обучение (Акт 0, шаг 5): что где в профиле, дальше — в «Настройки фигур» -->
    <TutorialSpotlight
      v-if="tutProfile"
      target=".profile__actions"
      :title="$tut('tut.profileTourTitle')"
      :text="$tut('tut.profileTour')"
      :counter="tutCounter"
      :next-label="$tut('tut.profileToPack')"
      :portrait="tutPortrait"
      @next="tutToPack"
      @skip="tutSkip"
    />
    <!-- ОБУЧЕНИЕ, Акт 0: дорога в задания дня — игрок сам жмёт кнопку в профиле -->
    <TutorialSpotlight
      v-if="tutDailyOpen"
      target="[data-tut='daily']"
      :title="$tut('tut.dailyOpenTitle')"
      :text="$tut('tut.dailyOpen')"
      :counter="tutCounter"
      :next-label="$tut('tut.dailyOpenGo')"
      :portrait="tutPortrait"
      @next="tutToDaily"
      @skip="tutSkip"
    />
    <!-- ОБУЧЕНИЕ, Акт 4, последний шаг: рефералка. Закрывает обучение целиком. -->
    <TutorialSpotlight
      v-if="tutRef"
      target=".profile__referral"
      :title="$tut('tut.compRefTitle')"
      :text="$tut('tut.compRef')"
      :counter="tutCounter"
      :next-label="$tut('tut.compDone')"
      :portrait="tutPortrait"
      @next="tutRefDone"
      @skip="tutSkip"
    />
    <!-- Чек-лист «Путь новичка» (обучение, волна 2): появляется после первой победы и ведёт
         новичка туда, куда подсказки уже не дотягиваются. Старым игрокам не показывается. -->
    <NewbiePath class="profile__path" />
    <!-- NFT-воины: что лежит на привязанном кошельке (web3 Э1 — только показ, в игру они пока не
         вводятся). 🔴 Высота блока задана в стилях и не зависит от содержимого: иначе появление
         списка после ответа сдвигало бы кнопки разделов под ним. -->
    <div class="profile__nft">
      <!-- ШАПКА: слева название с числом фигур, справа баланс токена и кнопки. Одна строка на ПК,
           две на телефоне — иначе баланс с семизначным числом выдавливает кнопки за край. -->
      <div class="profile__nft-head">
        <span class="profile__nft-title">
          {{ $t('profile.nft') }}<span v-if="tonLinked && tonItems.length" class="profile__nft-count">{{ nftShown.length }}</span>
        </span>
        <span v-if="tonLinked && !tonError" class="profile__nft-tools">
          <!-- ФИЛЬТР ПО ФРАКЦИИ: у владельца десятки фигур обеих сторон, а играет он за одну.
               🔴 Кнопки фракций показываем ТОЛЬКО когда есть из чего выбирать (обе стороны на
               кошельке): иначе это мёртвый переключатель, который лишь путает. -->
          <span v-if="tonHasBothFractions" class="profile__nft-filter">
            <button
              v-for="f in NFT_FILTERS" :key="f.key"
              class="profile__nft-btn profile__nft-btn--seg" :class="{ 'profile__nft-btn--on': nftFilter === f.key }"
              @click="nftFilter = f.key"
            >{{ f.label() }}</button>
          </span>
          <!-- 🔴 БАЛАНС И ОБМЕН — ОДНОЙ ГРУППОЙ: это про деньги, и рядом с ними не должно быть
               кнопок другого смысла. Раньше баланс, «Обменять», обновление и отвязка стояли одной
               лентой впритык, и «отвязать» оказывалась соседом кнопки обмена. -->
          <span class="profile__nft-money">
            <span class="profile__nft-balance" :title="$t('profile.walletBalanceHint')">
              <b>{{ tonJettonText }}</b> <span class="profile__nft-cur">$ENRG</span>
            </span>
            <!-- 🔴 ОБМЕН — ТОЛЬКО ВНЕ TELEGRAM (правила площадки: цифровое внутри мини-аппа продаётся
                 лишь за Stars). В мини-аппе на этом месте остаётся справочная строка ниже. -->
            <button
              v-if="exchangeAllowed" class="profile__nft-btn profile__nft-btn--main"
              :disabled="tonLoading || !tonJetton" @click="openExchange"
            >{{ $t('profile.exchangeOpen') }}</button>
          </span>
          <!-- Служебные действия — отдельной группой и приглушённые: отвязка кошелька выводит из
               игры все его фигуры, и по виду она не должна соперничать с «Обменять». -->
          <span class="profile__nft-service">
            <!-- когда данные были верны: снимок обновляет фоновый обход, и без отметки времени
                 устаревшие числа выглядят как свежие -->
            <span v-if="snapshotAge" class="profile__nft-age">{{ snapshotAge }}</span>
            <button
              class="profile__nft-btn profile__nft-btn--icon" :disabled="tonLoading"
              :title="$t('profile.walletRefresh')" @click="loadAssets(true)"
            >⟳</button>
            <button
              class="profile__nft-btn profile__nft-btn--quiet"
              :title="$t('profile.unlinkTitle')" @click="unlinkAsk = true"
            >{{ $t('profile.walletUnlink') }}</button>
          </span>
        </span>
      </div>
      <!-- 🔴 В МИНИ-АППЕ ОБМЕН ТОЛЬКО СПРАВОЧНО, без кнопки и без ссылки (правила Telegram: цифровое
           внутри Telegram продаётся только за Stars). Молчать нельзя — иначе владелец токена решит,
           что обмена нет вовсе. -->
      <!-- 🔴 У КАЖДОГО СООБЩЕНИЯ БЛОКА — КРЕСТИК (решение оунера 2026-09-11): игрок закрывает то, что
           прочитал, сам. Сервер тут ни при чём: отчёт сверки гасится запросом (`dismissNotices`),
           остальные строки — локальными флагами, то есть до следующей загрузки экрана. Ожидание
           обмена продолжает идти и после закрытия — крестик убирает строку, а не операцию. -->
      <div v-if="tonLinked && tgAvailable && !hideInApp" class="profile__nft-hint profile__nft-hint--x">
        {{ $t('profile.exchangeInApp') }}
        <button class="profile__nft-x" :title="$t('profile.nftNoticeClose')" :aria-label="$t('profile.nftNoticeClose')" @click="hideInApp = true">✕</button>
      </div>
      <!-- 🔴 ОБМЕН, КОТОРЫЙ ЕЩЁ В ПУТИ. Между подписью и зачислением проходят минуты, и раньше
           игрок не имел НИКАКОГО следа операции: закрыл окно — и остаётся гадать, ушли ли токены.
           Ожидание помнит сервер, поэтому плашка видна при любом заходе в профиль, пока не придёт. -->
      <div v-if="exPending && !hideExPending" class="profile__nft-hint profile__nft-hint--wait profile__nft-hint--x">
        {{ $t('profile.exchangePending', { n: exPending.amount }) }}
        <button class="profile__nft-x" :title="$t('profile.nftNoticeClose')" :aria-label="$t('profile.nftNoticeClose')" @click="hideExPending = true">✕</button>
        <!-- 🔴 КНОПКИ «ПРОВЕРИТЬ СЕЙЧАС» ЗДЕСЬ НЕТ И БЫТЬ НЕ ДОЛЖНО (решение оунера 2026-08-26).
             Она была очевидной идеей и продержалась один выкат: ручной опрос — это ровно тот спам к
             индексатору, от которого мы уходили зеркалом блокчейна, а нетерпеливый игрок жмёт её
             подряд. Ожидание закрывает фоновый сбор раз в минуту; экран просто честно называет срок.
             Гард стоит в `tools/ton-wallet-check.mjs` (сценарий «обмен в пути»). -->
      </div>
      <!-- Что случилось после отвязки: сколько фигур ушло и сколько вещей вернулось в сундук. -->
      <div v-if="tonNotice" class="profile__nft-hint profile__nft-hint--done profile__nft-hint--x">
        {{ tonNotice }}
        <button class="profile__nft-x" :title="$t('profile.nftNoticeClose')" :aria-label="$t('profile.nftNoticeClose')" @click="tonNotice = ''">✕</button>
      </div>
      <!-- 🔴 ОТЧЁТ СВЕРКИ ВЛАДЕНИЯ (Э2): фигура проданной NFT исчезает из армии, а вещи возвращаются
           в сундук — без объяснения это читается как «игра потеряла мои фигуры». Отчёт ждёт игрока
           (он копится на сервере), гасит его сам игрок кнопкой. -->
      <!-- 🔴 ПРОКРУЧИВАЕТСЯ ТОЛЬКО СПИСОК СТРОК, А КРЕСТИК СТОИТ НАД НИМ (в правом верхнем углу
           плашки, `position: absolute`). Отчётов бывает сразу много (у владельца коллекции — по
           фигуре в день), а высота блока постоянна: положи мы кнопку внутрь прокрутки, она уехала
           бы вниз, и погасить отчёт стало бы нечем. -->
      <div v-if="tonNotices.length" class="profile__nft-hint profile__nft-hint--notice">
        <button class="profile__nft-x" :title="$t('profile.nftNoticeClose')" :aria-label="$t('profile.nftNoticeClose')" @click="dismissNotices">✕</button>
        <div class="profile__nft-notes">
          <div v-for="(n, i) in tonNoticeLines" :key="i">{{ n }}</div>
        </div>
        <!-- 🔴 СКОЛЬКО ВСЕГО СООБЩЕНИЙ — ЧИСЛОМ. Строки едут внутри своей прокрутки, а в блоке
             постоянной высоты видно две-три: без счётчика игрок не знает, что под ними есть ещё,
             и гасит крестиком отчёт, которого не читал. -->
        <div v-if="tonNoticeLines.length > 1" class="profile__nft-notefoot">
          <span class="profile__nft-notecount">
            {{ $t('profile.nftNoticeCount', { n: tonNoticeLines.length }) }}
          </span>
        </div>
      </div>
      <!-- 🔴 ОШИБКА ПОКАЗЫВАЕТСЯ ПЕРВОЙ, ДАЖЕ ЕСЛИ КОШЕЛЁК НЕ ПРИВЯЗАН (жалоба оунера 2026-08-22:
           «игра не даёт подключить тот же кошелёк на другом аккаунте, но молчит»). Раньше ветка
           «подключите кошелёк» перехватывала показ, и отказ сервера игрок не видел вовсе. -->
      <div v-if="tonError" class="profile__nft-hint profile__nft-hint--error profile__nft-hint--x">
        {{ tonError }}
        <button v-if="tonLinked" class="profile__nft-btn" @click="loadAssets(true)">{{ $t('profile.walletRetry') }}</button>
        <button class="profile__nft-x" :title="$t('profile.nftNoticeClose')" :aria-label="$t('profile.nftNoticeClose')" @click="tonError = ''">✕</button>
      </div>
      <!-- 🔴 ПУСТОЕ СОСТОЯНИЕ ЦЕНТРИРУЕТСЯ. Блок держит `min-height` каркасом (кнопки разделов под
           ним не должны прыгать, когда приедет ответ), и одинокая строка в верхнем углу двухсот
           пустых пикселей выглядела недогрузившимся экраном, а не «фигур нет». -->
      <div v-else-if="!tonLinked" class="profile__nft-hint profile__nft-empty">{{ $t('profile.nftConnect') }}</div>
      <div v-else-if="tonLoading && !tonItems.length" class="profile__nft-hint profile__nft-empty">{{ $t('common.loading') }}</div>
      <div v-else-if="!tonItems.length" class="profile__nft-hint profile__nft-empty">{{ $t('profile.nftEmpty') }}</div>
      <div v-else-if="!nftShown.length" class="profile__nft-hint profile__nft-empty">{{ $t('profile.nftNoneInFilter') }}</div>
      <!-- 🔴 СЕТКА С ПЕРЕНОСОМ, А НЕ ОДНА СТРОКА С ПРОКРУТКОЙ (просьба оунера 2026-08-21): при
           горизонтальной ленте владелец видел только те фигуры, что влезли в ширину, а остальные
           надо было искать колесом — на телефоне это вообще незаметно. Блок растёт по содержимому. -->
      <div v-else class="profile__nft-list">
        <!-- 🔴 ПОКАЗЫВАЕМ СВОЙ СПРАЙТ ФИГУРЫ, А НЕ КАРТИНКУ ИЗ МЕТАДАННЫХ (решение оунера
             2026-08-21): та лежит на внешнем домене, её адрес приходит из кэша индексатора и
             бывает мёртвым — получались битые иконки. Фигуру опознаём по атрибутам NFT.
             Если арта нет вовсе — аккуратная рамка с номером, а не «сломанный файл». -->
        <!-- 🔴 Карточка КЛИКАБЕЛЬНА: по нажатию открывается окно со статами (фидбек оунера
             2026-08-21 — раньше на нажатие не происходило ничего). Фигуры, УЖЕ стоящие в
             расстановке, помечены: иначе владелец не понимает, какие из них играют. -->
        <button
          v-for="it in nftShown" :key="it.address"
          class="profile__nft-card" :class="{ 'profile__nft-card--in': it.in_squad }"
          :title="it.name || ''" @click="nftInfo = it"
        >
          <!-- 🔴 НОМЕР — В УГЛУ КАРТОЧКИ, А НЕ НА СПРАЙТЕ: поверх фигуры он закрывал ей шлем и
               голову, а у карточки угол всё равно пустой (спрайт центрирован). -->
          <span class="profile__nft-badge">#{{ it.index }}</span>
          <!-- 🔴 ЗАМОК = «на этой NFT запечён комплект» (просьба оунера 2026-08-24). Раньше это было
               видно только внутри карточки, и владелец коллекции не мог понять, какие фигуры уже
               оплачены, не открывая каждую. Тот же значок и тот же смысл, что в «Настройках фигур».
               Слева, потому что справа стоит номер. -->
          <span v-if="it.baked" class="profile__nft-lock" :title="$t('profile.nftBaked')">🔒</span>
          <span class="profile__nft-pic">
            <img
              v-if="spriteFor(it)"
              :src="spriteFor(it)" alt="" class="profile__nft-img" @error="onImageFail(it.address)"
            >
            <span v-else class="profile__nft-img profile__nft-img--none">?</span>
            <span v-if="it.in_squad" class="profile__nft-in">{{ $t('profile.nftInArmy') }}</span>
          </span>
          <span class="profile__nft-name">{{ it.name || ('#' + it.index) }}</span>
        </button>
      </div>
    </div>
    <!-- КАРТОЧКА NFT: статы фигуры В ИГРЕ, а не атрибуты из блокчейна (решение оунера 2026-08-22).
         Для фигуры в строю это статы С УЧЁТОМ НАДЕТОЙ АМУНИЦИИ — ровно то, что игрок будет запекать,
         поэтому вклад амуниции подсвечен зелёным (как в «Настройках фигур»). Для фигуры вне строя —
         статы её уровня, то есть «чем она станет». Разбор карточки (класс/подкласс/уровень) делает
         СЕРВЕР: правило уровня обязано жить в одном месте с правилом статов. -->
    <!-- 🔴 ОКНО ОБМЕНА $ENRG → ЭНЕРГИЯ (web3 Э4). Сжигание НЕОБРАТИМО, поэтому экран обязан сказать
         это до подписи, назвать точное число энергии и честно объяснить задержку: энергия приходит
         не по подписи, а когда транзакцию увидит блокчейн. -->
    <div v-if="exAsk" class="profile__nftdlg" @click.self="closeExchange">
      <div class="profile__nftdlg-box">
        <div class="profile__nftdlg-name">{{ $t('profile.exchangeTitle') }}</div>
        <div class="profile__nft-hint">{{ $t('profile.exchangeRate') }}</div>
        <div v-if="exDone" class="profile__nft-hint profile__nft-hint--done">
          {{ $t('profile.exchangeDone', { n: exDone }) }}
        </div>
        <div v-else-if="exWaiting" class="profile__nft-hint">{{ $t('profile.exchangeWaiting') }}</div>
        <div v-else-if="exError" class="profile__nft-hint profile__nft-hint--error">{{ exError }}</div>
        <div v-if="exNeedConnect && !exDone" class="profile__nft-hint">{{ $t('profile.exchangeNeedConnect') }}</div>
        <!-- 🔴 ВИДИМАЯ ДИАГНОСТИКА: три состояния кошелька (привязка / мост в браузере / подпись)
             снаружи неразличимы, и без этой строки «мигает окно» ничем не отличается от «отказал
             кошелёк». Пишем прямо, что библиотека думает про мост ПРЯМО СЕЙЧАС. -->
        <div v-if="exBridge && !exDone" class="profile__nft-hint">
          {{ exBridge.connected ? $t('profile.exchangeBridgeOn', { addr: shortAddr(exBridge.address) })
                                : $t('profile.exchangeBridgeOff') }}
        </div>
        <template v-if="!exDone">
          <label class="profile__ex-row">
            <span>{{ $t('profile.exchangeAmount') }}</span>
            <input
              v-model.number="exAmount" type="number" min="1" :max="tonJetton"
              class="profile__ex-input" :disabled="exBusy"
            >
          </label>
          <div class="profile__nft-hint">{{ $t('profile.exchangeGets', { n: exGets }) }}</div>
          <!-- Комиссию сети платит игрок: без GRAM кошелёк просто не отправит операцию, и молчаливый
               отказ читался бы как «кнопка не работает». -->
          <div class="profile__nft-hint">{{ $t('profile.exchangeGas') }}</div>
          <div v-if="exToday" class="profile__nft-hint">{{ $t('profile.exchangeToday', { n: exToday }) }}</div>
        </template>
        <div class="profile__nftdlg-acts">
          <!-- 🔴 ПОДКЛЮЧЕНИЕ И ПОДПИСЬ — РАЗНЫЕ ШАГИ, и подменять один другим нельзя: игрок нажал
               «Обменять», а кошелёк предложил привязку — он не понимает, что подтверждает. -->
          <button
            v-if="exNeedConnect && !exDone" class="profile__nft-btn" :disabled="exBusy"
            @click="connectForExchange"
          >{{ exBusy ? $t('profile.exchangeWaitWallet') : $t('profile.exchangeConnect') }}</button>
          <button
            v-else-if="!exDone" class="profile__nft-btn" :disabled="exBusy || !exValid"
            @click="doExchange"
          >{{ exBusy ? $t('profile.exchangeBusy') : $t('profile.exchangeOk') }}</button>
          <button class="profile__nft-btn" @click="closeExchange">{{ $t('common.close') }}</button>
        </div>
      </div>
    </div>
    <div v-if="nftInfo" class="profile__nftdlg" @click.self="nftInfo = null">
      <div class="profile__nftdlg-box">
        <div class="profile__nftdlg-head">
          <img v-if="spriteFor(nftInfo)" :src="spriteFor(nftInfo)" alt="" class="profile__nftdlg-img">
          <div>
            <div class="profile__nftdlg-name">{{ nftInfo.name || ('#' + nftInfo.index) }}</div>
            <div class="profile__nftdlg-sub">#{{ nftInfo.index }} · {{ nftKind }}</div>
            <div v-if="nftInfo.in_squad" class="profile__nftdlg-in">{{ $t('profile.nftInArmyFull') }}</div>
            <div v-else-if="nftInfo.unit_id" class="profile__nftdlg-in profile__nftdlg-in--bench">{{ $t('profile.nftOnBench') }}</div>
            <div v-if="nftInfo.baked" class="profile__nftdlg-in profile__nftdlg-in--baked">{{ $t('profile.nftBaked') }}</div>
            <!-- 🔴 БОНУС ЗА ВЗЯТИЕ ВИДЕН В ИНТЕРФЕЙСЕ: иначе игрок не отличит «бонуса нет» от
                 «бонус не работает» (жалоба оунера 2026-08-23). Проценты считает сервер. -->
            <div v-if="nftBonus" class="profile__nftdlg-in profile__nftdlg-in--bonus">
              {{ $t('profile.nftEnergyBonus', { pct: nftBonus }) }}
            </div>
          </div>
          <span v-if="nftPower !== null" class="profile__nftdlg-power">
            {{ $t('game.power') }}: <b>{{ nftPower }}</b>
          </span>
        </div>
        <div v-if="nftStats.length" class="profile__nftdlg-note">{{ nftStatsNote }}</div>
        <div v-if="nftStats.length" class="profile__nftdlg-stats">
          <div
            v-for="r in nftStats" :key="r.key"
            class="profile__nftdlg-row" :class="{ 'profile__nftdlg-row--up': r.boosted }"
          >
            <span>{{ r.label }}</span><span>{{ r.value }}{{ r.pct ? '%' : '' }}</span>
          </div>
        </div>
        <div v-else class="profile__nft-hint">{{ $t('profile.nftNoStats') }}</div>
        <div class="profile__nftdlg-acts">
          <!-- 🔴 «Разблокировать» и «Забрать в игру» — ОДНА операция (`WEB3_PLAN §9.2`), разные
               подписи: у владельца это «передумал продавать», у покупателя — «получил купленное». -->
          <button
            v-if="nftInfo.baked" class="profile__nft-btn" :disabled="bakeBusy"
            @click="askBake(nftInfo, true)"
          >{{ takeMode ? $t('profile.takeOk') : $t('profile.unbakeOk') }}</button>
          <button
            v-else-if="nftInfo.unit_id" class="profile__nft-btn" :disabled="bakeBusy || !bakeReady"
            :title="bakeReady ? '' : $t('profile.bakeNoGear')" @click="askBake(nftInfo, false)"
          >{{ $t('profile.bakeOk') }}</button>
          <button class="profile__nft-btn" @click="nftInfo = null">{{ $t('common.close') }}</button>
        </div>
      </div>
    </div>
    <!-- 🔴 ЗАПЕКАНИЕ ОБЪЯСНЯЕТСЯ ДО НАЖАТИЯ И ОТЧИТЫВАЕТСЯ ШАГАМИ (`WEB3_PLAN §9.9`): игрок платит
         за него энергией и по этому окну судит, за что именно заплатил. -->
    <div v-if="bakeAsk" class="profile__nftdlg" @click.self="closeBake">
      <div class="profile__nftdlg-box">
        <div class="profile__nftdlg-name">
          {{ bakeAsk.unbake ? (takeMode ? $t('profile.takeTitle') : $t('profile.unbakeTitle')) : $t('profile.bakeTitle') }}
        </div>
        <template v-if="!bakeDone">
          <div class="profile__nftdlg-note">
            {{ bakeAsk.unbake ? $t('profile.unbakeWarn') : $t('profile.bakeWarn') }}
          </div>
          <div v-if="!bakeAsk.unbake" class="profile__nftdlg-note">
            {{ $t('profile.bakePrice', { n: bakeAsk.price }) }}
          </div>
        </template>
        <template v-else>
          <div class="profile__nftdlg-steps">
            <div v-for="st in bakeSteps" :key="st.key" class="profile__nftdlg-step">
              <span>{{ st.done ? '✔' : '…' }}</span><span>{{ st.label }}</span>
            </div>
          </div>
          <div v-if="!bakeDone.card_updated" class="profile__nftdlg-note">{{ $t('profile.bakeCardWait') }}</div>
          <div class="profile__nftdlg-note">{{ $t('profile.bakeGetgems') }}</div>
        </template>
        <div v-if="bakeError" class="profile__nft-hint profile__nft-hint--error">{{ bakeError }}</div>
        <div class="profile__nftdlg-acts">
          <button
            v-if="!bakeDone" class="profile__nft-btn" :disabled="bakeBusy" @click="runBake"
          >{{ bakeAsk.unbake ? (takeMode ? $t('profile.takeOk') : $t('profile.unbakeOk')) : $t('profile.bakeOk') }}</button>
          <button class="profile__nft-btn" @click="closeBake">{{ $t('common.close') }}</button>
        </div>
      </div>
    </div>
    <!-- 🔴 ОТВЯЗКА СПРАШИВАЕТ ПОДТВЕРЖДЕНИЕ: вместе с кошельком из игры уходят его NFT-фигуры, и
         игрок обязан понимать это ДО нажатия, а не увидеть пропажу постфактум. -->
    <div v-if="unlinkAsk" class="profile__nftdlg" @click.self="unlinkAsk = false">
      <div class="profile__nftdlg-box">
        <div class="profile__nftdlg-name">{{ $t('profile.unlinkTitle') }}</div>
        <div class="profile__nftdlg-note">{{ $t('profile.unlinkWarn', { n: nftInGame }) }}</div>
        <div class="profile__nftdlg-note">{{ $t('profile.unlinkGear') }}</div>
        <div class="profile__nftdlg-acts">
          <button class="profile__nft-btn" :disabled="tonBusy" @click="onUnlink">{{ $t('profile.unlinkOk') }}</button>
          <button class="profile__nft-btn" @click="unlinkAsk = false">{{ $t('common.close') }}</button>
        </div>
      </div>
    </div>
    <div class="profile__actions">
      <!-- Мягкий гейтинг (TUTORIAL_PLAN §5): колесо и рынок новичку до первой партии не нужны —
           показываем приглушёнными с подписью, а не прячем (разделы должны быть ВИДНЫ). -->
      <button
        v-if="packEnabled" class="profile__btn" :class="{ 'profile__btn--locked': lockedForNewbie }"
        :disabled="lockedForNewbie" :title="lockedForNewbie ? $tut('tut.lockedHint') : ''"
        @click="$router.push('/wheel')"
      >{{ $t('profile.wheel') }}</button>
      <button
        v-if="packEnabled" class="profile__btn" :class="{ 'profile__btn--locked': lockedForNewbie }"
        :disabled="lockedForNewbie" :title="lockedForNewbie ? $tut('tut.lockedHint') : ''"
        @click="$router.push('/market')"
      >{{ $t('profile.market') }}</button>
      <!-- Магазин временно отключён (2026-07-14): ТОП-шмот за энергию = имбаланс. Оставлен под будущую внутриигровую торговлю. -->
      <!-- <button v-if="packEnabled" class="profile__btn" @click="$router.push('/shop')">Магазин</button> -->
      <!-- Турниры убраны из профиля (2026-07-26, решение оунера): вход в раздел — из главного меню. -->
      <!-- Задания дня — вход отсюда (перенесены из главного меню, решение оунера 2026-07-28) -->
      <button v-if="packEnabled" class="profile__btn" data-tut="daily" @click="$router.push('/daily')">
        {{ $t('menu.daily') }}
        <span v-if="dailyBadge" class="profile__badge">{{ dailyBadge }}</span>
      </button>
      <button v-if="packEnabled" class="profile__btn" @click="$router.push('/pack')">{{ $t('profile.settingsFigures') }}</button>
      <!-- 🔴 МАГАЗИН ЗА ЗВЁЗДЫ ВИДЕН, ТОЛЬКО ЕСЛИ КАССА ВКЛЮЧЕНА В АДМИНКЕ. Признак приходит тем же
           ответом `/users/overview` (поле `stars_shop.enabled`) — отдельного запроса нет, и ряд
           кнопок не переезжает после его ответа. Выключенная касса отвечает на `/stars/*` 404, и
           кнопка вела бы игрока в пустой экран. -->
      <!-- 🔴 МЕСТО ПОД КНОПКУ ЗАНЯТО, ПОКА ОТВЕТ В ПУТИ (жалоба оунера 2026-08-31 «кнопки появляются
           с задержкой»): флаг `stars_shop.enabled` приезжает с `/users/overview`, и на телефоне
           кнопки идут колонкой — появление ещё одной удлиняло ряд на целую строку. -->
      <button
        v-if="packEnabled && (starsShop || overviewPending)" class="profile__btn"
        :class="{ 'profile__btn--pending': !starsShop }" @click="$router.push('/stars')"
      >{{ $t('profile.starsShop') }}</button>
      <!-- 🔴 Кнопки Telegram переехали ОТСЮДА в шапку профиля, к «Выйти» и «Сменить пароль»
           (просьба оунера 2026-08-23): в этом ряду они ловили промахи мимо «Настроек фигур», а по
           смыслу это операции с АККАУНТОМ, а не разделы игры. -->
    </div>

    <!-- Окно привязки с сайта: ссылка открывает мини-приложение в Telegram игрока и привязывает
         аккаунт по одноразовому коду. -->
    <div v-if="tgLinkOpen" class="pf__pwd-back" @click.self="closeTgLink">
      <div class="pf__pwd">
        <div class="pf__pwd-title">{{ $t('profile.tgLink') }}</div>
        <div class="pf__tgwidget-hint">{{ $t('profile.tgAppHint') }}</div>
        <div v-if="tgCodeUrl" class="pf__tgcode">
          <a class="profile__btn pf__tgcode-btn" :href="tgCodeUrl" target="_blank" rel="noopener">{{ $t('profile.tgOpenApp') }}</a>
          <div class="pf__tgwidget-hint">{{ $t('profile.tgCodeHint') }}</div>
        </div>
        <div class="pf__pwd-btns">
          <button class="profile__btn" @click="closeTgLink">{{ $t('common.close') }}</button>
        </div>
      </div>
    </div>

    <div v-if="tgMessage" class="pf__tgmsg">{{ tgMessage }}</div>

    <!-- ОКНО СМЕНЫ ПАРОЛЯ (волна 5.2). Требует старый пароль: одной открытой сессии мало, иначе
         укравший токен просто отобрал бы аккаунт. Успех = новый токен в cookie и предупреждение,
         что все прочие входы (в том числе турнирные) завершены. -->
    <div v-if="pwdOpen" class="pf__pwd-back" @click.self="closePwd">
      <div class="pf__pwd">
        <div class="pf__pwd-title">{{ $t('profile.changePassword') }}</div>
        <label class="pf__pwd-row">
          <span>{{ $t('profile.pwdOld') }}</span>
          <input type="password" v-model="pwdOld" autocomplete="current-password">
        </label>
        <label class="pf__pwd-row">
          <span>{{ $t('profile.pwdNew') }}</span>
          <input type="password" v-model="pwdNew" autocomplete="new-password">
        </label>
        <div v-if="pwdError" class="pf__pwd-err">{{ pwdError }}</div>
        <div v-if="pwdDone" class="pf__pwd-ok">{{ $t('profile.pwdChanged') }}</div>
        <div class="pf__pwd-hint">{{ $t('profile.pwdHint') }}</div>
        <div class="pf__pwd-btns">
          <button class="profile__btn" :disabled="pwdBusy" @click="submitPwd">{{ $t('common.ok') }}</button>
          <button class="profile__btn" @click="closePwd">{{ $t('common.close') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import thumb from "../assets/ZombElf06.webp"
import TutorialHelp from '@/components/tutorial/TutorialHelp';
import NewbiePath from '@/components/tutorial/NewbiePath';
import TutorialSpotlight from '@/components/tutorial/TutorialSpotlight';
import { waitReward } from '@/components/tutorial/flow';
import { mentorPortrait } from '@/components/tutorial/mentor';
import { serverError } from '@/i18n/serverErrors';
import { applyAuthHeader, setJwt } from '@/session';
import { bakeNft, burnTokens, clearWalletNotices, collectExchange, connectWallet, connectWalletForSend, disconnectWallet, exchangeStatus, markExchangeSent, tonEnabled, walletAssets, walletBridge, walletStatus } from '@/ton';
import { fractionOf, spriteCandidates } from '@/components/web-game/nftSprite';
import { STAT_KEYS } from '@/components/web-game/unitStats';
import { statShort, PERCENT_FIELDS } from '@/components/web-game/effectFmt';
import { t } from '@/i18n';
import {
  isTelegram,
  telegramLinkCode,
  telegramLink,
  telegramLinkConfig,
  telegramUnlink,
} from '@/telegram';

// Самоцветы (4 вида; спрайтов нет — CSS-ромбы по цвету). Ключ = основа поля player_resources,
// суффикс размера (_s/_m/_l/_u/_leg). То же, что в PagePack — панель ресурсов повторно.
// Подписи берём из локали в computed (см. ниже) — при смене языка панель перерисовывается сама.
const GEM_COLORS = { topaz: '#f2b544', ruby: '#e0475a', sapphire: '#3f7fe8', diamond: '#d9f1ff' };
const GEM_KEYS = ['topaz', 'ruby', 'sapphire', 'diamond'];
const GEM_SIZE_KEYS = ['s', 'm', 'l', 'u', 'leg'];
const MATERIAL_ICONS = { wood: '🪵', stone: '🪨', iron: '⛓️' };
const MATERIAL_KEYS = ['wood', 'stone', 'iron'];
// Бусты ежедневных заданий: те же ключи и иконки, что в «Настройках фигур» и на Рынке
const BOOST_ICONS = {
  boost_minutes: '⏳', scroll_apprentice: '📜', scroll_master: '📕', ether: '🧊', hammer: '🔨', hospital: '✚',
  whetstone: '⚒️', transform_stone: '🔮', chisel: '🔪',
};
const BOOST_KEYS = ['boost_minutes', 'scroll_apprentice', 'scroll_master', 'ether', 'hammer', 'hospital',
  'whetstone', 'transform_stone', 'chisel'];

export default {
  name: "PageProfile",
  components: { TutorialHelp, NewbiePath, TutorialSpotlight },
  data: function () {
    return {
      thumb: thumb,
      resources: null, // GET /ammo/resources: самоцветы/материалы + рейтинг/баланс энергии
      starsShop: false, // касса Telegram Stars включена в админке (флаг из /users/overview)
      openGem: null,   // раскрытый по тапу список размеров
      hoverGem: null,  // раскрытый по наведению
      referral: null,  // GET /users/referral: {code, invited, tickets}
      copied: false,   // отметка «скопировано» на кнопке реф-ссылки
      // смена пароля (волна 5.2)
      pwdOpen: false,
      tgBusy: false,      // идёт привязка телеграм-аккаунта
      tgMessage: '',      // результат привязки (успех или переведённый отказ сервера)
      tgLinkedNow: false, // привязали в этой сессии — кнопку сразу убираем
      tgLinkOpen: false,  // окно «привязать через мини-приложение»
      tgCodeLink: false,  // сервер умеет выдать код (есть имя бота И короткое имя мини-аппа)
      tgCfgPending: true, // ответ `/users/telegram/config` ещё в пути → кнопка держит место каркасом
      overviewPending: true, // ответ `/users/overview` ещё в пути → кнопка магазина держит место
      tgCodeUrl: '',      // готовая ссылка «открыть мини-апп и привязать по коду»
      pwdOld: '',
      pwdNew: '',
      pwdError: '',
      pwdDone: false,
      pwdBusy: false,
      // КОШЕЛЁК TON (web3 Э1). `tonReady` — сервер подтвердил, что раздел включён; пока не
      // подтвердил, кнопка ведёт себя как прежняя надпись и ничего не делает.
      tonReady: false,
      tonLinked: false,
      tonShort: '',
      tonBusy: false,     // идёт подключение/отвязка
      tonLoading: false,  // читаем активы с блокчейна
      tonError: '',
      tonJetton: 0,
      tonItems: [],
      tonNotices: [],
      tonSnapshot: null,  // {source: 'mirror'|'live', age_seconds} — откуда данные и какой давности
      // отчёт сверки владения: что случилось с фигурами проданных/выставленных NFT
      exAsk: false,    // открыто окно обмена $ENRG → энергия
      exAmount: 1,
      exBusy: false,
      exWaiting: false,  // подпись прошла, ждём транзакцию в блокчейне
      exDeferred: 0,     // сколько энергии отложил дневной предел (сжигание увидели, зачтём завтра)
      exDone: 0,         // сколько энергии зачислено (показываем итог)
      exError: '',
      exConf: { min_amount: 1, daily_limit: 0, enabled: true },
      exToday: 0,
      exNeedConnect: false,  // мост до кошелька мёртв: сперва отдельная кнопка «Подключить»
      exBridge: null,        // что библиотека думает про кошелёк (видимая диагностика в окне)
      spriteStep: {},   // адрес фигуры → какой по счёту кандидат спрайта пробуем (арт есть не для всех)
      tonNotice: '',    // итог отвязки («фигур убрано… вещей вернулось…»)
      // 🔴 Крестики сообщений, которые живут НЕ на сервере: игрок закрыл строку — она не мозолит
      // глаза до следующей загрузки экрана. Само ожидание обмена при этом продолжает идти, поэтому
      // флаг сбрасывается, как только сервер называет ДРУГУЮ сумму (watcher `exPending`) — новое
      // ожидание обязано показаться, даже если прошлое игрок закрыл.
      hideExPending: false,
      hideInApp: false,
      bakeAsk: null,    // открытое окно запекания/разблокировки {item, unbake, price}
      bakeBusy: false,
      bakeDone: null,   // отчёт сервера после операции (по нему рисуем галочки шагов)
      bakeError: '',
      unlinkAsk: false, // открыто окно подтверждения отвязки
      nftFilter: 'all', // фильтр списка NFT по фракции: all | elf | zombie
      nftInfo: null,    // открытая карточка NFT (окно со статами)
      NFT_FILTERS: [
        { key: 'all', label: () => t('profile.nftAll') },
        { key: 'elf', label: () => t('unit.Elf') },
        { key: 'zombie', label: () => t('unit.Zombie') },
      ],
    }
  },
  computed: {
    // Баланс токена с разделителями разрядов: 35566213 → «35 566 213». Семизначное число сплошняком
    // не читается, а игрок сверяет его с кошельком. Локаль берём из языка интерфейса.
    tonJettonText() {
      const n = Number(this.tonJetton || 0);
      try {
        return n.toLocaleString(this.$i18n && this.$i18n.locale === 'en' ? 'en-US' : 'ru-RU');
      } catch (e) {
        return String(n);
      }
    },
    // 🔴 СТАТЫ ФИГУРЫ В ИГРЕ, А НЕ АТРИБУТЫ ИЗ БЛОКЧЕЙНА (решение оунера 2026-08-22). Считает их
    // СЕРВЕР (`/ton/assets` → `stats`): у фигуры в строю — с надетой амуницией (это и есть предмет
    // будущего запекания), у остальных — база её уровня. Порядок строк и подписи — те же, что в
    // блоке статов «Настроек фигур»: игрок сравнивает две карточки глазами.
    nftStats() {
      const info = this.nftInfo || {};
      const stats = info.stats || null;
      if (!stats || !stats.values) return [];
      const base = stats.base || null;
      return STAT_KEYS.filter((k) => k !== 'power').map((k) => {
        const value = Number(stats.values[k] || 0);
        const from = base ? Number(base[k] || 0) : value;
        // пустые регены не показываем — так же, как в «Настройках фигур» (пустые строки только шумят)
        if (k.endsWith('_regeneration') && !value && !from) return null;
        return {
          key: k,
          label: statShort(k),
          value: Math.round(value * 10) / 10,
          pct: PERCENT_FIELDS.has(k),
          boosted: value > from,  // зелёным то, что подняла амуниция
        };
      }).filter(Boolean);
    },
    // Сила фигуры — та же, по которой считается цена запекания (снапшот, не проседает от ран).
    nftPower() {
      const stats = (this.nftInfo || {}).stats;
      if (!stats || !stats.values || stats.values.power === undefined) return null;
      return Math.round(Number(stats.values.power));
    },
    // Строки отчёта сверки владения: по фигуре на строку + сколько вещей вернулось в сундук.
    // «Данные от блокчейна такой-то давности». Свежее минуты — не пишем ничего: строка нужна,
    // чтобы поймать УСТАРЕВШЕЕ, а не мельтешить секундами при каждом заходе.
    snapshotAge() {
      const box = this.tonSnapshot;
      if (!box || box.source !== 'mirror') return '';
      const sec = Number(box.age_seconds || 0);
      if (!Number.isFinite(sec) || sec < 60) return '';
      const min = Math.round(sec / 60);
      return min < 60 ? t('profile.dataAgeMin', { n: min }) : t('profile.dataAgeHour', { n: Math.round(min / 60) });
    },
    exPending() {
      const p = (this.exConf || {}).pending;
      return p && p.amount ? p : null;
    },
    tonNoticeLines() {
      return (this.tonNotices || []).map((n) => {
        // 🔴 ИМЯ ФИГУРЫ СОБИРАЕТСЯ, ТОЛЬКО ЕСЛИ ОНО ПРИШЛО (жалоба оунера 2026-09-11: на экране
        // висело «NFT-воин (unit.undefined - unit.undefined) больше не в вашем кошельке»). У отчёта
        // о возврате из аренды класса и подкласса не было вовсе, а строка собиралась безусловно —
        // `$t('unit.undefined')` печатает сам ключ. Нет полей → говорим просто «фигура».
        const who = [n.type && t(`unit.${n.type}`), n.rank && t(`unit.${n.rank}`)]
          .filter(Boolean).join(' · ') || t('profile.nftSomeFigure');
        // 🔴 Зачисление обмена приходит тем же отчётом: он ЖДЁТ игрока на сервере и гасится его
        // кнопкой. Иначе энергия приходила молча — игрок не замечал, когда именно (жалоба 2026-08-24).
        if (n.kind === 'exchange') return t('profile.nftNoticeExchange', { n: n.amount });
        // 🔴 ВОЗВРАТ ИЗ АРЕНДЫ — СВОЙ ВИД ОТЧЁТА, А НЕ «ФИГУРА УШЛА». Без своей ветки он падал в
        // общую и пугал владельца текстом про потерю NFT. **Заводя новый `kind` на сервере, заводи
        // ветку и здесь: иначе игрок прочитает чужую новость.**
        if (n.kind === 'rent_back') {
          const head = t('profile.nftNoticeRentBack', { who });
          const tail = n.relisted ? ` ${t('rent.relisted')}` : '';
          return n.returned ? `${head} ${t('profile.nftNoticeItems', { n: n.returned })}${tail}` : head + tail;
        }
        const head = n.kind === 'listed'
          ? t('profile.nftNoticeListed', { who })
          : t('profile.nftNoticeGone', { who });
        return n.returned ? `${head} ${t('profile.nftNoticeItems', { n: n.returned })}` : head;
      });
    },
    // Обмен доступен: раздел включён, кошелёк привязан и мы НЕ в мини-аппе (правила Telegram).
    exchangeAllowed() {
      return this.tonLinked && !this.tgAvailable && this.exConf.enabled !== false;
    },
    // Сколько энергии придёт: курс 1:1, но округляем ввод до целого — токен неделим (decimals 0).
    exGets() {
      return Math.max(0, Math.floor(Number(this.exAmount) || 0));
    },
    exValid() {
      const n = this.exGets;
      return n >= (this.exConf.min_amount || 1) && n <= (this.tonJetton || 0);
    },
    // Прибавка к энергии за взятие фигуры противника ЭТОЙ фигурой (+30% обычная NFT, +50% древняя).
    // Считает сервер (`/ton/assets` → `energy_bonus`): своя копия правила разъехалась бы с игрой.
    nftBonus() {
      const pct = Number((this.nftInfo || {}).energy_bonus || 0);
      return pct > 0 ? Math.round(pct) : 0;
    },
    // «Ладья · Лучник · ур. 5» — то, чем NFT является в игре (разбор пришёл с сервера).
    nftKind() {
      const info = this.nftInfo || {};
      const parts = [];
      if (info.type) parts.push(t(`unit.${info.type}`));
      if (info.rank) parts.push(t(`unit.${info.rank}`));
      if (info.level) parts.push(t('pack.levelShort') + info.level);
      return parts.join(' · ');
    },
    // Подпись над статами: с амуницией это или «как будет при вводе в игру».
    nftStatsNote() {
      const stats = (this.nftInfo || {}).stats || {};
      if (!stats.in_game) return t('profile.nftStatsPreview');
      return stats.equipped
        ? t('profile.nftStatsWithAmmo', { n: stats.equipped })
        : t('profile.nftStatsNoAmmo');
    },
    // Фигуры кошелька после фильтра по фракции.
    nftShown() {
      if (this.nftFilter === 'all') return this.tonItems;
      return this.tonItems.filter((it) => fractionOf(it) === this.nftFilter);
    },
    // Фильтр показываем, только когда на кошельке есть ОБЕ стороны — иначе он бесполезен.
    // Запекать есть что, только если на фигуре надета амуниция (сервер считает это же).
    bakeReady() {
      const stats = (this.nftInfo || {}).stats || {};
      return !!stats.equipped;
    },
    // Комплект запечён, а на фигуре его нет → это КУПЛЕННАЯ фигура: кнопка зовётся «Забрать в игру».
    takeMode() {
      const card = this.bakeAsk ? this.bakeAsk.item : this.nftInfo;
      const stats = (card || {}).stats || {};
      return !!(card && card.baked && !stats.equipped);
    },
    bakeSteps() {
      const done = this.bakeDone || {};
      const unbake = !!(this.bakeAsk && this.bakeAsk.unbake);
      const steps = [
        { key: 'kit', label: unbake ? t('profile.bakeStepFree') : t('profile.bakeStepKit'), done: true },
        { key: 'card', label: t('profile.bakeStepCard'), done: !!done.card_updated },
      ];
      if (!unbake) steps.unshift({ key: 'paid', label: t('profile.bakeStepPaid'), done: true });
      return steps;
    },
    // Сколько NFT кошелька заведено в игре: столько фигур уйдёт при отвязке.
    nftInGame() {
      return this.tonItems.filter((it) => it.unit_id).length;
    },
    tonHasBothFractions() {
      const kinds = new Set(this.tonItems.map((it) => fractionOf(it)).filter(Boolean));
      return kinds.size > 1;
    },
    // Бейдж на кнопке «Задания дня»: сколько наград можно забрать прямо сейчас.
    dailyBadge() { return this.$store.getters.dailyBadge; },
    // Привязка Telegram: кнопка нужна ТОЛЬКО внутри мини-аппа (вне его привязывать нечего) и только
    // пока аккаунт не привязан. Свежесозданный телеграм-игрок сюда не попадёт — у него `telegram_id`
    // проставлен с рождения.
    tgAvailable() { return isTelegram(); },
    tgLinked() { return this.tgLinkedNow || !!this.$store.state.auth.telegramId; },
    tutPortrait() { return mentorPortrait(this.$store.state.pvp.fraction); },
    // шаг «что в профиле»: показываем, пока не открыто окно награды (окна не накладываем)
    tutProfile() {
      return this.$store.getters.tutorialActive
        && this.$store.getters.tutorialStep === 'profile_tour'
        && !this.$store.getters.tutorialBusy;
    },
    // Акт 0: «загляни в задания дня» — подсвечиваем кнопку раздела в профиле
    tutDailyOpen() {
      return this.$store.getters.tutorialActive
        && this.$store.getters.tutorialStep === 'daily_open'
        && !this.$store.getters.tutorialBusy;
    },
    // Акт 4, последний шаг: рефералка (блок есть только когда сервер отдал реф-код)
    tutRef() {
      return this.$store.getters.tutorialActive
        && this.$store.getters.tutorialStep === 'comp_ref'
        && !this.$store.getters.tutorialBusy
        && !!this.referral;
    },
    tutCounter() {
      const p = this.$store.getters.tutorialProgress;
      if (!p || !p.act) return '';
      return `${this.$tut('tut.' + p.act)} · ${this.$tut('tut.stepOf', { n: Math.min(p.n + 1, p.total), total: p.total })}`;
    },
    // мягкий гейтинг: колесо и рынок открываются после первой партии (TUTORIAL_PLAN §5)
    lockedForNewbie() {
      return this.$store.getters.tutorialActive && !this.$store.getters.tutorialActDone('act1');
    },
    GEMS() { return GEM_KEYS.map((k) => ({ key: k, label: this.$t(`res.${k}`), color: GEM_COLORS[k] })); },
    GEM_SIZES() {
      const map = { s: 'sizeS', m: 'sizeM', l: 'sizeL', u: 'sizeU', leg: 'sizeLeg' };
      return GEM_SIZE_KEYS.map((k) => ({ key: k, label: this.$t(`res.${map[k]}`) }));
    },
    MATERIALS() { return MATERIAL_KEYS.map((k) => ({ key: k, label: this.$t(`res.${k}`), icon: MATERIAL_ICONS[k] })); },
    // Бусты (пески времени, свитки, эфир, молот) — показываем только те, что есть
    // Бусты показываем ВСЕ, включая нулевые: пустая ячейка — тоже информация, а главное, высота
    // блока перестаёт зависеть от данных (иначе панель «дорастает» и двигает всё, что ниже).
    BOOSTS() {
      return BOOST_KEYS.map((k) => ({ key: k, label: this.$t(`daily.res.${k}`), icon: BOOST_ICONS[k] }));
    },
    profile(){
      return this.$store.state.auth;
    },
    packEnabled(){
      return process.env.VUE_APP_ENABLE_WEB_CLIENT === 'true';
    },
    ratingDisplay(){
      // рейтинг = энергия × винрейт (та же формула, что в лидерборде); фолбэк на стор, если бэк без /ammo/resources
      if (!this.resources) return this.profile.energy;
      return this.resources.leaderboard_rating != null ? this.resources.leaderboard_rating : this.resources.rating;
    },
    energyDisplay(){
      // баланс = рейтинг - потраченное вне партий; фолбэк на стор
      return this.resources ? this.resources.energy_balance : this.profile.energy;
    },
    referralLink(){
      return this.referral ? `${window.location.origin}/?ref=${this.referral.code}` : '';
    }
  },
  mounted(){
    // Общий профиль показывает store.auth (кэш ОСНОВНОГО аккаунта) — в активном сезоне это привело бы к
    // путанице (шапка — старые данные родителя, а панель ресурсов ниже дёрнула бы уже СЕЗОННЫЙ баланс по
    // подменённому токену). Уводим на рабочий стол сезона вместо смешанного показа.
    if (this.$store.state.season.active) { this.$router.push('/tournament'); return; }
    this.fetchOverview();
    // Кнопка «Привязать Telegram» на САЙТЕ (вне мини-аппа) ведёт в мини-приложение, поэтому нужны имя
    // бота И короткое имя мини-аппа — они приходят с сервера (у стейджа и прода боты разные).
    // Не настроено/старый сервер → кнопки просто нет: жать её было бы некуда.
    if (!isTelegram()) {
      telegramLinkConfig(this.axios)
        .then((c) => { this.tgCodeLink = !!(c || {}).code_link; })
        .finally(() => { this.tgCfgPending = false; });
    }
    // Бейдж заданий: тянем состояние раздела здесь — вход в задания теперь из профиля.
    if (this.packEnabled) {
      this.$store.dispatch('fetchDaily');
      // обучение: игрок дошёл до профиля — общий подхват промотает `profile_open` (и любой застрявший
      // ранее инфо-шаг) и покажет `profile_tour`. Заменяет прежнюю точечную страховку по одному шагу.
      this.$store.dispatch('fetchTutorial');
    }
    // Кошелёк TON: спрашиваем сервер, включён ли раздел, и подтянуто ли уже состояние привязки.
    // 🔴 Под try/catch и без await в общей цепочке: отказ этого запроса не имеет права уносить
    // инициализацию всего экрана (то же правило, что у остальных `dispatch` в `mounted`).
    this.initWallet();
  },
  watch: {
    // 🔴 ЗАКРЫТОЕ КРЕСТИКОМ ОЖИДАНИЕ ВОЗВРАЩАЕТСЯ, КОГДА ОНО ДРУГОЕ. Игрок закрыл строку про прошлый
    // обмен, сделал новый — и не увидел бы про него ни слова: флаг-то уже стоит. Сравниваем СУММУ
    // (другая операция — другое ожидание), а не факт наличия поля.
    'exPending.amount': function resetHideExPending() { this.hideExPending = false; },
  },
  methods: {
    // ─── КОШЕЛЁК TON (web3 Э1: только привязка и показ) ─────────────────────────────────────────
    async initWallet(){
      try {
        this.tonReady = await tonEnabled();
        if (!this.tonReady) return;
        const st = await walletStatus();
        this.applyWalletStatus(st);
        if (this.tonLinked) this.loadAssets();
      } catch (e) { /* сервер старый или раздел выключен — блок остаётся прежней надписью */ }
    },
    // 🔴 `serverError` принимает СТРОКУ (`detail` ответа), а не объект axios: передашь ошибку целиком —
    // игрок увидит «AxiosError: Request failed with status code 503». Ловит `tools/ton-wallet-check.mjs`.
    tonFail(e){
      const detail = ((e || {}).response || {}).data || {};
      return serverError(String(detail.detail || '')) || this.$t('common.networkError');
    },
    // Отказ ПРИВЯЗКИ: у неё есть свои коды из `@/tonFlow` (кошелёк не отпустил мост, игрок закрыл
    // окно, не дождались подтверждения) — без них игрок видел бы «сеть недоступна» или вообще
    // ничего, а кнопка молча оставалась бы в состоянии «ждём».
    walletFail(e){
      const code = String((e && e.message) || '');
      // 🔴 Молчать нельзя даже про отмену: если наш вердикт «игрок отменил» окажется ложным, экран
      // не покажет НИЧЕГО, и это читается как «кнопка не работает» (жалоба оунера 2026-08-22).
      if (code === 'cancelled') return this.$t('profile.walletCancelled');
      if (code === 'no-proof') return this.$t('profile.walletNoProof');
      if (code === 'wallet-busy') return this.$t('profile.walletBusy');
      if (code === 'timeout') return this.$t('profile.walletTimeout');
      // 🔴 В браузере подключён НЕ ТОТ кошелёк: подписать он смог бы, но сгорели бы его токены, а
      // энергию мы начислили бы владельцу привязки. Объясняем прямо, что делать.
      if (code === 'wallet-mismatch') return this.$t('profile.walletMismatch');
      // 🔴 Текст, который вернул сам кошелёк или библиотека — показываем КАК ЕСТЬ. Он некрасивый, но
      // это единственное, что объясняет отказ; без него «ничего не происходит» неотличимо от отмены.
      if (e && e.walletText) return this.$t('profile.walletRaw', { text: e.walletText });
      return this.tonFail(e);
    },
    // Спрайт NFT-фигуры: сперва точный (с подклассом), при ошибке загрузки — следующий кандидат.
    spriteFor(it){
      const list = spriteCandidates(it);
      return list[this.spriteStep[it.address] || 0] || null;
    },
    onImageFail(address){
      // арта по этому пути нет — пробуем менее точный; кончились кандидаты → останется номер
      this.spriteStep = { ...this.spriteStep, [address]: (this.spriteStep[address] || 0) + 1 };
    },
    applyWalletStatus(st){
      this.tonLinked = !!(st && st.linked);
      this.tonShort = (st && st.short) || '';
      if (!this.tonLinked) { this.tonItems = []; this.tonJetton = 0; this.spriteStep = {}; }
      if (this.tonLinked) this.tonNotice = '';
    },
    async onWallet(){
      if (!this.tonReady || this.tonBusy) return;
      // Привязанный кошелёк по нажатию только показывает адрес целиком: отвязка — отдельной
      // кнопкой в блоке NFT, чтобы случайный тап по шапке не разрывал привязку.
      if (this.tonLinked) { this.loadAssets(true); return; }
      this.tonBusy = true;
      this.tonError = '';
      try {
        this.applyWalletStatus(await connectWallet());
        if (this.tonLinked) this.loadAssets(true);
      } catch (e) {
        this.tonError = this.walletFail(e);
      } finally {
        this.tonBusy = false;
      }
    },
    askBake(item, unbake){
      // карточку закрываем: два окна друг на друге игрок читает как зависший интерфейс
      this.nftInfo = null;
      this.bakeAsk = { item, unbake, price: item.bake_price || 0 };
      this.bakeDone = null;
      this.bakeError = '';
    },
    closeBake(){
      this.bakeAsk = null;
      this.bakeDone = null;
      this.bakeError = '';
    },
    async runBake(){
      if (this.bakeBusy || !this.bakeAsk) return;
      this.bakeBusy = true;
      this.bakeError = '';
      try {
        const out = await bakeNft(this.bakeAsk.item.unit_id, this.bakeAsk.unbake);
        this.bakeDone = out || {};
        await this.loadAssets(true);   // карточки перечитываем: сменились метка, цена и статы
      } catch (e) {
        this.bakeError = this.tonFail(e);
      } finally {
        this.bakeBusy = false;
      }
    },
    async onUnlink(){
      if (this.tonBusy) return;
      this.tonBusy = true;
      this.tonError = '';
      this.tonNotice = '';
      try {
        const st = await disconnectWallet();
        this.applyWalletStatus(st);
        this.unlinkAsk = false;
        // Вместе с кошельком из игры ушли его фигуры — говорим, что стало с их амуницией.
        const rel = (st && st.released) || {};
        if (rel.units) {
          this.tonNotice = this.$t('profile.unlinkDone', { u: rel.units, n: rel.returned || 0 });
        }
        // ростер изменился (вернулись стоковые фигуры) — «Настройки фигур» перечитают его сами
      } catch (e) {
        this.tonError = this.tonFail(e);
      } finally {
        this.tonBusy = false;
      }
    },
    shortAddr(a){
      const t = String(a || '');
      return t.length > 12 ? `${t.slice(0, 6)}…${t.slice(-4)}` : t;
    },
    async openExchange(){
      this.exAsk = true;
      this.exError = '';
      this.exDone = 0;
      this.exDeferred = 0;
      this.exWaiting = false;
      this.exNeedConnect = false;
      this.exAmount = Math.min(this.tonJetton || 1, this.exAmount || 1) || 1;
      await this.loadExchangeState();
      this.exBridge = await walletBridge();
      // мост уже мёртв — не заставляем игрока сперва наткнуться на отказ
      if (!this.exBridge.connected) this.exNeedConnect = true;
    },
    closeExchange(){
      // 🔴 ЗАКРЫТИЕ ОКНА НЕ ОТМЕНЯЕТ ОПЕРАЦИЮ (аудит 2026-08-29). Раньше «Закрыть» снимало признак
      // занятости, пока запрос ещё висел в кошельке: игрок закрывал окно, открывал заново и жал
      // «Обменять» второй раз — уходила ВТОРАЯ транзакция, то есть сгорал второй раз реальный
      // токен. Признак снимает только сам проход (`finally` в `doExchange`), а окно — это всего
      // лишь окно; ожидание зачисления и так живёт на сервере.
      this.exAsk = false;
    },
    async doExchange(){
      if (this.exBusy || !this.exValid) return;
      this.exBusy = true;
      this.exError = '';
      try {
        await burnTokens(this.exGets);
        // 🔴 СРАЗУ ПОСЛЕ ПОДПИСИ ГОВОРИМ СЕРВЕРУ, ЧТО ЗАЧИСЛЕНИЕ В ПУТИ. Дальше игрок волен закрыть
        // окно и вкладку: ожидание живёт на сервере, профиль покажет его при следующем заходе, а
        // приход энергии догонит игрока отчётом. Раньше на этом месте след операции обрывался.
        await markExchangeSent(this.exGets);
        this.exConf = { ...(this.exConf || {}), pending: { amount: this.exGets } };
        // 🔴 Подпись — это НЕ зачисление: спрашиваем сервер, пока транзакция не появится в блокчейне.
        // Не дождались — не беда: фоновый сбор на сервере подберёт её сам, о чём и пишем игроку.
        this.exWaiting = true;
        const got = await this.pollExchange();
        this.exWaiting = false;
        if (got) {
          this.exDone = got;
          await this.fetchOverview();  // баланс энергии в шапке обязан обновиться сразу
          await this.loadAssets(true); // и остаток токенов на кошельке
        } else if (this.exDeferred) {
          this.exError = t('profile.exchangeDeferred', { n: this.exDeferred });
        } else {
          this.exError = t('profile.exchangeSlow');
        }
      } catch (e) {
        this.exWaiting = false;
        // 🔴 Мост до кошелька мёртв — это не ошибка, а НЕДОСТАЮЩИЙ ШАГ: показываем кнопку
        // подключения вместо непонятного отказа.
        if (String((e && e.message) || '') === 'not-connected') {
          this.exNeedConnect = true;
          this.exError = '';
        } else {
          // те же коды, что у привязки (отмена, выход по времени, чужой кошелёк) — молчать нельзя
          this.exError = this.walletFail(e);
        }
      } finally {
        this.exBusy = false;
      }
    },
    async connectForExchange(){
      if (this.exBusy) return;
      this.exBusy = true;
      this.exError = '';
      try {
        await connectWalletForSend();
        this.exBridge = await walletBridge();
        this.exNeedConnect = !this.exBridge.connected;
      } catch (e) {
        // «superseded» — игрок сам начал новый проход, ругаться незачем
        if (String((e && e.message) || '') !== 'superseded') this.exError = this.walletFail(e);
      } finally {
        this.exBusy = false;
      }
    },
    // Спрашиваем сервер несколько раз: транзакция появляется за секунды, но индексатор бывает отстаёт.
    // 🔴 ЖДЁМ ДОЛЬШЕ МИНУТЫ (замер на проде 2026-08-26). Прежнее окно было ровно 12×5 с = минута, а
    // реальный путь операции: подпись 07:54:10 → запись в снимке 07:55:12. Экран разминулся с ней на
    // ДВЕ СЕКУНДЫ, сдался, и дальше игрок ждал фоновый таймер, глядя на плашку «обмен в пути».
    // Теперь ~3.5 минуты: первые полминуты частым шагом (обычный случай), дальше реже — опрос
    // дешёвый, но при мёртвом снимке сервер идёт в блокчейн, и частить там незачем.
    async pollExchange(tries = 18, fast = 6, pause = 5000, slow = 15000){
      for (let i = 0; i < tries; i += 1) {
        try {
          const out = await collectExchange();
          if (out && out.amount) return out.amount;
          // 🔴 СЖИГАНИЕ УВИДЕЛИ, НО ОТЛОЖИЛИ ДНЕВНЫМ ПРЕДЕЛОМ — про это надо СКАЗАТЬ. Иначе экран
          // молчит до конца опроса и пишет «энергия придёт сама», а игрок не понимает, почему её
          // нет: токены-то сгорели. Ждать дальше незачем — раньше завтра ничего не изменится.
          if (out && out.deferred) { this.exDeferred = out.deferred_amount || 0; return 0; }
        } catch (e) { /* блокчейн недоступен — просто пробуем ещё раз */ }
        await new Promise((r) => setTimeout(r, i < fast ? pause : slow));
      }
      return 0;
    },
    async dismissNotices(){
      this.tonNotices = [];
      try { await clearWalletNotices(); } catch (e) { /* отчёт вторичен: не смогли погасить — покажем снова */ }
    },
    async loadAssets(force = false){
      if (!this.tonLinked || this.tonLoading) return;
      this.tonLoading = true;
      this.tonError = '';
      try {
        const data = await walletAssets(force);
        this.tonJetton = (data && data.jetton) || 0;
        this.tonItems = (data && data.items) || [];
        this.tonNotices = (data && data.notices) || [];
        // 🔴 ВОЗРАСТ ДАННЫХ ПОКАЗЫВАЕМ ИГРОКУ. Профиль отвечает из снимка блокчейна, который
        // собирает фоновый обход, — и молча устаревшие числа игрок читает как настоящие. Строка
        // рядом с кнопкой «⟳» отвечает на вопрос «когда это было верно».
        this.tonSnapshot = (data && data.snapshot) || null;
        this.spriteStep = {};     // список обновился — начинаем подбор спрайтов заново
        // 🔴 СОСТОЯНИЕ ОБМЕНА ТЯНЕМ СРАЗУ, А НЕ ПРИ ОТКРЫТИИ ОКНА: плашка «обмен в пути» обязана
        // встретить игрока при обычном заходе в профиль — он для того и закрыл окно, что ждать долго.
        // Запрос дешёвый: сервер отвечает из своей базы, в блокчейн за этим не ходит.
        this.loadExchangeState();
      } catch (e) {
        // 🔴 Недоступный блокчейн — это ОТДЕЛЬНОЕ состояние блока, а не пустой список: иначе игрок
        // с NFT решит, что мы их «потеряли».
        this.tonError = this.tonFail(e);
      } finally {
        this.tonLoading = false;
      }
    },
    async loadExchangeState(){
      try {
        const data = await exchangeStatus();
        this.exConf = {
          min_amount: data.min_amount || 1,
          daily_limit: data.daily_limit || 0,
          enabled: data.enabled !== false,
          pending: data.pending || null,
        };
        this.exToday = data.today || 0;
      } catch (e) { /* настройки не критичны: сервер всё равно проверит их при подготовке */ }
    },
    async tutToPack(){
      await this.$store.dispatch('tutorialStepDone', 'profile_tour');
      await waitReward(this.$store);
      this.$router.push('/pack');
    },
    tutSkip(){ this.$store.dispatch('tutorialSkip'); },
    async tutToDaily(){
      await this.$store.dispatch('tutorialStepDone', 'daily_open');
      await waitReward(this.$store);
      this.$router.push('/daily');
    },
    // последний шаг обучения: после него `step` становится `done` и кнопка меню — «Справка»
    async tutRefDone(){
      await this.$store.dispatch('tutorialStepDone', 'comp_ref');
    },
    // 🔴 ОДИН ЗАПРОС НА ВЕСЬ ЭКРАН (просьба оунера 2026-08-10): кошелёк и реф-блок приезжают вместе,
    // поэтому профиль дорисовывается ОДИН раз. Раньше это были два запроса, и каждый ответ двигал
    // ряд кнопок и всё, что ниже. Фолбэк на старые роуты — для сборки фронта поверх старого бэка.
    async fetchOverview(){
      this.overviewPending = true;
      try {
        const r = await this.axios.get('/users/overview');
        const d = r.data || {};
        this.resources = d.resources || null;
        this.referral = d.referral || null;
        this.starsShop = !!(d.stars_shop && d.stars_shop.enabled);
      } catch (_) {
        await Promise.all([this.fetchResources(), this.fetchReferral()]);
      } finally { this.overviewPending = false; }
    },
    async fetchReferral(){
      try {
        const r = await this.axios.get('/users/referral');
        this.referral = r.data;
      } catch (_) { this.referral = null; /* старый бэк без рефералки — блок скрыт */ }
    },
    openPwd(){
      this.pwdOpen = true;
      this.pwdOld = '';
      this.pwdNew = '';
      this.pwdError = '';
      this.pwdDone = false;
    },
    closePwd(){ this.pwdOpen = false; },
    async linkTelegram(){
      this.tgBusy = true;
      this.tgMessage = '';
      try {
        await telegramLink(this.axios);
        this.tgLinkedNow = true;
        this.tgMessage = this.$t('profile.tgLinked');
      } catch (e) {
        const detail = ((e || {}).response || {}).data || {};
        this.tgMessage = serverError(String(detail.detail || '')) || this.$t('profile.tgLinkFailed');
      }
      this.tgBusy = false;
    },
    /**
     * Привязка с САЙТА — через мини-приложение (единственный путь с 2026-08-18).
     *
     * 🔴 ВИДЖЕТ TELEGRAM УБРАН ПО РЕШЕНИЮ ОУНЕРА: кнопку входа рисовал сам Telegram, и у игроков она
     * часто не появлялась вовсе (нет `/setdomain` у бота, другое написание домена, блокировщик) —
     * человек упирался в пустое окно. Ссылка в мини-апп открывает тот же Telegram игрока, но ни от
     * домена, ни от сторонних скриптов не зависит. Код просим СРАЗУ: ждать ещё одного нажатия незачем.
     */
    openTgLink(){
      this.tgMessage = '';
      this.tgCodeUrl = '';
      this.tgLinkOpen = true;
      this.askLinkCode();
    },
    // Одноразовый код и готовая ссылка в мини-апп (живут 10 минут, см. `/users/telegram/link_code`).
    async askLinkCode(){
      this.tgBusy = true;
      try {
        const data = await telegramLinkCode(this.axios);
        this.tgCodeUrl = (data || {}).url || '';
      } catch (e) {
        const detail = ((e || {}).response || {}).data || {};
        this.tgMessage = serverError(String(detail.detail || '')) || this.$t('profile.tgLinkFailed');
        this.tgLinkOpen = false; // окно без ссылки бесполезно — причину показываем плашкой
      }
      this.tgBusy = false;
    },
    closeTgLink(){
      this.tgCodeUrl = '';
      this.tgLinkOpen = false;
    },
    // Отвязать телеграм от этого аккаунта (перевесить его на другой свой аккаунт).
    async unlinkTelegram(){
      this.tgBusy = true;
      this.tgMessage = '';
      try {
        await telegramUnlink(this.axios);
        this.tgLinkedNow = false;
        this.$store.commit('SET_TELEGRAM_ID', null);
        this.tgMessage = this.$t('profile.tgUnlinked');
      } catch (e) {
        const detail = ((e || {}).response || {}).data || {};
        this.tgMessage = serverError(String(detail.detail || '')) || this.$t('profile.tgLinkFailed');
      }
      this.tgBusy = false;
    },
    async submitPwd(){
      this.pwdError = '';
      this.pwdDone = false;
      this.pwdBusy = true;
      try {
        const r = await this.axios.post('/users/password', {
          old_password: this.pwdOld,
          new_password: this.pwdNew,
        });
        // 🔴 СРАЗУ ПОДМЕНЯЕМ ТОКЕН: сервер отозвал все прежние сессии, включая нашу собственную —
        // без подмены следующий же запрос этого клиента вернул бы 401 и игрока выбросило бы из игры.
        const fresh = (r.data || {}).access_token;
        if (fresh) {
          setJwt(fresh);
          applyAuthHeader(this.axios, fresh);
          // 🔴 ИМЕННО `SET_JWT`, А НЕ `SET_TOKEN` (аудит 2026-08-30). `state.token` — это СТАРЫЙ
          // логин-токен, который `TRY_AUTH` отправляет QUERY-ПАРАМЕТРОМ (`GET /?token=…`): свежий
          // JWT оседал бы в логах прокси. А сам `state.jwt` при этом оставался ОТОЗВАННЫМ, и
          // `REFRESH_TOKEN` (он берёт `state.jwt` первым) продлевал бы мёртвый токен — то есть
          // смена пароля роняла игрока при следующем же продлении сессии.
          this.$store.commit('SET_JWT', fresh);
        }
        this.pwdDone = true;
        this.pwdOld = '';
        this.pwdNew = '';
      } catch (e) {
        const detail = ((e || {}).response || {}).data;
        const text = typeof detail === 'string' ? detail : (detail || {}).detail;
        this.pwdError = text ? serverError(String(text)) : this.$t('login.failed');
      } finally {
        this.pwdBusy = false;
      }
    },
    async copyReferral(){
      try {
        await navigator.clipboard.writeText(this.referralLink);
      } catch (_) {
        const el = document.querySelector('.profile__referral-link');
        if (el) { el.select(); document.execCommand('copy'); }
      }
      this.copied = true;
      setTimeout(() => { this.copied = false; }, 1500);
    },
    logout() {
      this.$store.dispatch('LOGOUT', this);
      this.$router.push('/');
    },
    // «У меня уже есть аккаунт в игре»: выходим из телеграм-аккаунта к форме входа и оставляем метку —
    // App.vue привяжет Telegram сразу после входа логином и паролем, чтобы игрок не искал кнопку снова.
    switchToOwnAccount() {
      localStorage.setItem('cz_tg_link_after_login', '1');
      this.logout();
    },
    async fetchResources(){
      try {
        const r = await this.axios.get('/ammo/resources');
        this.resources = r.data;
      } catch (_) { this.resources = null; /* старый бэк без эндпоинта — панель скрыта */ }
    },
    // значение кошелька до ответа сервера (чипы стоят с первого кадра ради стабильной вёрстки)
    resVal(key){ return (this.resources || {})[key] || 0; },
    gemTotal(gemKey){
      if (!this.resources) return 0;
      return GEM_SIZE_KEYS.reduce((s, sz) => s + (this.resources[`${gemKey}_${sz}`] || 0), 0);
    },
    gemBreakdown(gemKey){
      return this.GEM_SIZES.map((sz) => ({ ...sz, count: (this.resources && this.resources[`${gemKey}_${sz.key}`]) || 0 }));
    },
    gemPopupOpen(gemKey){ return this.openGem === gemKey || this.hoverGem === gemKey; },
    toggleGem(gemKey){ this.openGem = this.openGem === gemKey ? null : gemKey; }
  }
}
</script>

<style scoped lang="scss">

// ОКНО СМЕНЫ ПАРОЛЯ (волна 5.2). Поверх экрана, закрывается кликом по фону; поля обычные,
// без «скинов» — форма редкая и должна читаться, а не быть частью декора.
.pf__tgmsg{
  margin: 8px auto 0;
  max-width: 520px;
  font-size: 13px;
  color: #ffe9a8;
  text-align: center;
  overflow-wrap: anywhere;
}
.pf__pwd-back{
  position: fixed; inset: 0; z-index: 60;
  display: flex; align-items: center; justify-content: center;
  background: rgba(0,0,0,.6);
}
.pf__pwd{
  box-sizing: border-box;
  width: min(360px, 92vw);
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  padding: 18px;
  border: 1px solid #6b5a3a; border-radius: 10px;
  background: #241a30; color: #fff;
  text-align: left; line-height: 1.35;
}
.pf__pwd-title{ font-size: 18px; margin-bottom: 12px; text-align: center; }
.pf__pwd-row{
  display: block; margin-bottom: 10px; font-size: 14px;
  span{ display: block; margin-bottom: 4px; opacity: .85; }
  input{
    box-sizing: border-box; width: 100%; padding: 8px 10px;
    border: 1px solid #6b5a3a; border-radius: 6px;
    background: #16101f; color: #fff; font-size: 15px;
  }
}
.pf__pwd-err{ color: #ff9a9a; font-size: 13px; margin: 6px 0; overflow-wrap: anywhere; }
.pf__pwd-ok{ color: #9ae6a0; font-size: 13px; margin: 6px 0; }
.pf__pwd-hint{ font-size: 12px; opacity: .7; margin: 8px 0 12px; }
.pf__pwd-btns{ display: flex; gap: 10px; justify-content: center; }
.pf__tgwidget-hint{ font-size: 13px; opacity: .8; margin: 8px 0 12px; line-height: 1.35; }
// кнопку внутри рисует сам Telegram (iframe) — нам достаточно центрировать место под неё
.pf__tgwidget{ display: flex; justify-content: center; min-height: 48px; margin-bottom: 12px; }
// Запасной путь привязки: ссылка на мини-апп с одноразовым кодом (когда виджет не появился).
.pf__tgcode{ margin-bottom: 4px; }
.pf__tgcode-btn{ display: inline-block; text-decoration: none; }
// Бейдж «сколько наград ждёт» на кнопке «Задания дня» (пункт переехал из главного меню).
// 🔴 Бейдж ВНЕ ПОТОКА: в потоке он расширял кнопку «Задания» на свою ширину, и когда ответ
// `/daily` доезжал, ряд кнопок (flex-wrap + center) перестраивался — последняя кнопка
// «Настройки фигур» прыгала в другую строку и обратно (жалоба оунера 2026-08-10).
.profile__badge {
  position: absolute; top: -7px; right: -4px;  // на УГЛУ кнопки: внутри он наезжал на надпись
  min-width: 18px; padding: 0 5px;
  border-radius: 9px; background: #ffcf94; color: #2a1c3c;
  font-size: .72em; font-weight: 700; line-height: 18px; text-align: center;
}
  .profile{
    display: grid;
    gap: 1em;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 50px auto repeat(3, auto);
    color: yellow;
    &__face{
      max-width: 200px;
      grid-row-start: 1;
      grid-row-end: 4;
      background: url("../assets/chain.webp") repeat-y 15%, url("../assets/chain.webp") repeat-y 85%;
      background-size: 15px;
      margin-top: 2em;
      // 🔴 РАССТОЯНИЕ МЕЖДУ ТАБЛИЧКАМИ ЗАДАЁТ `gap`, А НЕ `margin-bottom` У КАЖДОЙ (просьба оунера
      // 2026-08-23 «выровняй кнопки под аватаркой»). Отступ у каждой таблички свой и в `em`, то
      // есть он зависит от РАЗМЕРА ШРИФТА кнопки: у приглушённой отвязки Telegram шрифт мельче —
      // и зазор под ней получался меньше остальных. У кошелька отступа не было вовсе, поэтому
      // Telegram липла к нему вплотную. Один `gap` на колонку делает шаг одинаковым по построению.
      display: flex;
      flex-direction: column;
      gap: 1em;
    }
    // 🔴 ОТСТУПЫ — В ПРОЦЕНТАХ ОТ ШИРИНЫ ТАБЛИЧКИ, А НЕ В `em` (фикс 2026-08-14, жалоба оунера
    // «энергия и рейтинг вылезают за края спрайтов»). Фон `category.webp` растянут на 100% ширины, а
    // «чистое» тёмное поле у него занимает 10.4%..90.3% (замерено по картинке) — остальное декоративные
    // концы и рамка. Отступ в `em` привязан к РАЗМЕРУ ШРИФТА и при другой ширине блока (широкий экран,
    // мобилка, длинное число) переставал совпадать с этим полем: текст наезжал на завиток спрайта.
    // Проценты держат текст внутри поля при ЛЮБОЙ ширине.
    &__rating, &__energy{
      background: url("../assets/category.webp") no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding: 0 12%;
      min-height: 50px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.8em;
      overflow: hidden;
    }
    &__box-label{
      text-transform: uppercase;
      font-size: 0.78em;
      opacity: 0.85;
      white-space: nowrap;
    }
    &__box-val{
      font-weight: 700;
      font-size: 1em;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      min-width: 0;  // без этого flex-элемент не даёт себя ужать, и длинное число распирало блок
    }
    &__resources{
      grid-column: 2 / 4;
      // резерв высоты одного ряда кошельков: панель приходит отдельным запросом, и без резерва её
      // появление подбрасывало статистику, блок NFT и ряд кнопок (жалоба оунера 2026-08-10)
      min-height: 40px;
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      align-content: flex-start;
    }
    // до ответа сервера чипы уже стоят на своих местах — просто приглушены (значения нулевые):
    // блок не «появляется последним», и ничего под ним не сдвигается, когда данные доехали
    &__resources--pending{
      opacity: 0.45;
      .pf__res-val{ visibility: hidden; }
    }
    // рамки кошельков: самоцветы / материалы / бусты
    .pf__res-group{
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      padding: 5px;
      border: 1px solid rgba(150, 130, 220, .45);
      border-radius: 10px;
      background: rgba(0, 0, 0, .18);
    }
    .pf__res-group--gems{ border-color: rgba(229, 194, 100, .55); }
    .pf__res-group--mat{ border-color: rgba(156, 107, 63, .6); }
    .pf__res-group--boost{ border-color: rgba(120, 190, 220, .55); }
    &__statistic{
      grid-column-start: 2;
      grid-column-end: 4;
      background: url("../assets/profile_border.webp") no-repeat, url("../assets/profiletile.webp");
      background-size: 100% 100%;
      color: #000;
      padding: 1em 2em;
      text-align: left;
      line-height: 1.15;
      &__title{
        text-align: center;
      }
    }
    // чек-лист «Путь новичка» — во всю ширину под статистикой
    &__path{
      grid-column: 1 / 4;
    }
    &__nft{
      grid-column-start: 1;
      grid-column-end: 4;
      background: url("../assets/profile_border.webp") no-repeat, url("../assets/profiletile.webp");
      background-size: 100% 100%;
      // 🔴 ОТСТУПЫ ПОД УЗОРНУЮ РАМКУ, А НЕ РОВНЫЙ 1em (жалоба оунера 2026-08-23: «всё вылазит за
      // рамки»). Фон `profile_border.webp` — это РАМКА С УЗОРОМ, растянутая на весь блок: по бокам
      // и особенно в углах она съедает заметную полосу. При `padding: 1em` заголовок налезал на
      // левый завиток, кнопка отвязки — на правый, а крайняя карточка ряда уходила под рамку.
      // Боковой отступ берём как у соседней «Статистики» (2em) и добавляем запас снизу.
      // 🔴 Поднят до 2.4em (жалоба оунера 2026-09-11, второй круг: «текст не залазит на графику»):
      // при 2em длинная строка отчёта и заголовок «NFT-воины» упирались прямо в завиток узора —
      // формально внутри блока, а на вид лежали на рамке.
      padding: 1.4em 2.4em 1.5em;
      box-sizing: border-box;
      // 🔴 ВЫСОТА БЛОКА ПОСТОЯННА, СПИСОК ПРОКРУЧИВАЕТСЯ ВНУТРИ (жалоба оунера 2026-08-31: «при
      // появлении НФТ-воинов окно расширяется и весь интерфейс прыгает»). Раньше здесь стоял
      // `min-height` и блок РОС под содержимое: список приезжает отдельным ответом `/ton/assets`,
      // и его приход сдвигал вниз кнопки разделов. Теперь место одно и то же при любом числе
      // фигур — то же решение, что у таблицы лидеров в лобби.
      // 🔴 260 → 340 (просьба оунера 2026-09-11: «расширить область для NFT, чтобы всё в неё влазило
      // нормально»). При 260 блок вмещал ОДИН ряд карточек, а с отчётом сверху — ни одного целого:
      // отчёт и список делят постоянную высоту, и чего-то одного всегда не хватало.
      height: 340px;
      color: #000;
      // колонка нужна, чтобы пустое состояние могло занять оставшуюся высоту и встать по центру
      display: flex; flex-direction: column;
    }
    // «фигур нет» / «подключите кошелёк» — по центру пустого блока, а не строкой в верхнем углу
    // 🔴 Приглушаем ЦВЕТОМ, а не `opacity`: прозрачность подмешивает светлый пергамент в буквы, и
    // строка выцветает пятнами (жалоба оунера 2026-09-11 «очень блекло смотрится на фоне подложки»).
    &__nft-empty{
      flex: 1; justify-content: center; text-align: center;
      min-height: 3em; opacity: 1; color: #5a4020;
    }
    .btn{
      grid-column-start: 2;
      grid-column-end: 2;
      background: url("../assets/category.webp") no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding: 0 1.5em;
      height: 50px;
      width: 150px;
      display: flex;
      align-items: center;
      justify-content: center;
      justify-self: center;
      text-transform: uppercase;
    }
    &__photo{
      height: 200px;
      width: 200px;
      overflow: hidden;
      border-radius: 100%;
      position: relative;
      top: -2em;
      background: red;
      &:before{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        content: '';
        background: url("../assets/facering.webp") no-repeat;
        background-size: 100% 100%;
      }
      img{
        height: 100%;
        width: 100%;
      }
    }
    // 🔴 ОДНА ВЫСОТА У ВСЕХ ТАБЛИЧЕК. `padding: 1em` считается от размера шрифта КНОПКИ, поэтому у
    // приглушённой отвязки Telegram (шрифт мельче) табличка выходила ниже соседних, и ряд выглядел
    // сбитым даже при равных зазорах. Фиксированная минимальная высота + центрирование по вертикали
    // делают ряд ровным при любом размере подписи и переносе длинного ника на две строки.
    &__username, &__logout-top, &__wallet{
      box-sizing: border-box;
      min-height: 52px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &__username{
      background: url("../assets/proflie-card.webp") no-repeat;
      background-size: 100% 100%;
      padding: 0.6em 1em;
      text-transform: uppercase;
      color: #8b8579;
      // 🔴 ДЛИННЫЙ НИК ПЕРЕНОСИТСЯ, А НЕ ВЫЛЕЗАЕТ ЗА ТАБЛИЧКУ (фикс 2026-08-14). Ник задаёт игрок,
      // и длина у него любая; фон растянут по размеру блока (`background-size: 100% 100%`), поэтому
      // блок спокойно становится выше — а вот выехавший за рамку текст выглядел поломкой.
      text-align: center;
      overflow-wrap: anywhere;
      box-sizing: border-box;
    }
    // «Выйти» между ником и кошельком: ТА ЖЕ табличка, что у ника (решение оунера 2026-07-30) —
    // отличается только золотой подписью, как у кошелька: это действие, а не поле с данными.
    &__logout-top{
      width: 100%;
      background: url("../assets/proflie-card.webp") no-repeat;
      background-size: 100% 100%;
      padding: 0.6em 1em;
      border: 0;
      font: inherit;
      text-transform: uppercase;
      color: #f4ac11;
      font-weight: 600;
      cursor: pointer;
      transition: filter .15s ease, transform .15s ease;

      &:hover{ filter: brightness(1.12); }
      &:active{ transform: translateY(1px); }
      &:disabled{ cursor: default; opacity: .6; }
      // отвязка Telegram — то же место и та же табличка, но подпись приглушена: это редкое действие
      // «перевесить аккаунт», и по яркости оно не должно спорить с «Выйти» и «Сменить пароль»
      &--muted{ color: #c9b184; font-weight: 500; font-size: .92em; }
    }
    &__wallet{
      background: url("../assets/proflie-wallet.webp") no-repeat;
      background-size: 100% 100%;
      padding: 0.6em 1em;
      // 🔴 ВЫСОТА КНОПКИ НЕ ЗАВИСИТ ОТ НАДПИСИ: «Подключить кошелёк» занимает две строки, а адрес
      // привязанного кошелька — одну, и после ответа `/ton/status` шапка становилась на 7 px ниже
      // (а с ней уезжало всё, что под ней). Держим высоту по САМОЙ длинной надписи.
      min-height: 59px;
      text-transform: uppercase;
      color: #f4ac11;
      font-weight: 600;
      // кнопкой блок стал в web3 Э1 — гасим браузерные умолчания, вид остаётся прежним
      border: 0;
      width: 100%;
      font-family: inherit;
      font-size: inherit;
      cursor: pointer;
      &:disabled{ cursor: default; opacity: .75; }
      &--linked{ color: #9fe3a0; text-transform: none; }
    }
    // Содержимое блока NFT-воинов (web3 Э1). Высота самого блока задана выше и НЕ зависит от
    // содержимого: список приезжает отдельным запросом и не должен двигать кнопки разделов.
    // ШАПКА блока: название с числом фигур слева, баланс и кнопки справа.
    // 🔴 ШАПКА НЕ ПРИЖИМАЕТСЯ К КРАЯМ И НЕ СЛИПАЕТСЯ В ЛЕНТУ. Три смысловые группы (фильтр —
    // деньги — служебное) разделены зазором, между ними разрешён перенос: на узком экране группа
    // уезжает на вторую строку целиком, а не рвётся посередине.
    &__nft-head{
      display: flex; align-items: center; justify-content: space-between;
      gap: .5em 1.1em; flex-wrap: wrap; margin-bottom: .7em;
      border-bottom: 1px solid rgba(0, 0, 0, .22); padding-bottom: .55em;
    }
    &__nft-title{
      font-weight: 700; font-size: 1.05em; letter-spacing: .01em;
      display: inline-flex; align-items: center;
    }
    // счётчик фигур рядом с названием — сразу видно, сколько их всего
    &__nft-count{
      display: inline-flex; align-items: center; justify-content: center;
      margin-left: .5em; min-width: 1.7em; padding: 0 .4em;
      border-radius: 999px; background: rgba(20, 14, 36, .8); color: #ffe;
      font-size: .74em; font-weight: 700; line-height: 1.7;
      font-variant-numeric: tabular-nums;
    }
    &__nft-tools{ display: flex; align-items: center; gap: .45em 1.1em; flex-wrap: wrap; }
    // фильтр фракций — сегментированный переключатель: кнопки СЛИТЫ в один элемент, выбранная залита
    &__nft-filter{
      display: inline-flex;
      border: 1px solid rgba(0, 0, 0, .35); border-radius: 7px; overflow: hidden;
    }
    &__nft-btn--seg{
      border: 0; border-radius: 0; padding: .18em .8em;
      + .profile__nft-btn--seg{ border-left: 1px solid rgba(0, 0, 0, .25); }
    }
    &__nft-btn--on{
      background: rgba(20, 14, 36, .82); color: #ffe;
      &:hover{ background: rgba(20, 14, 36, .92); }
    }
    // группа «деньги»: баланс и обмен читаются как одно целое
    &__nft-money{ display: inline-flex; align-items: center; gap: .45em; }
    &__nft-balance{
      // 🔴 Цифры моноширинные: баланс меняется, и «прыгающая» ширина числа дёргала бы кнопки рядом.
      font-variant-numeric: tabular-nums;
      display: inline-flex; align-items: baseline; gap: .3em;
      padding: .2em .7em; border-radius: 999px;
      border: 1px solid rgba(196, 150, 60, .55);
      background: linear-gradient(180deg, rgba(255, 226, 150, .55), rgba(226, 178, 74, .35));
      font-size: .9em;
      b{ font-size: 1.1em; font-weight: 700; }
    }
    &__nft-cur{ font-size: .82em; opacity: 1; color: #5a4526; letter-spacing: .03em; }
    &__nft-service{ display: inline-flex; align-items: center; gap: .35em; }
    &__nft-btn{
      border: 1px solid rgba(0, 0, 0, .35); background: rgba(255, 255, 255, .5);
      border-radius: 7px; padding: .18em .7em; cursor: pointer; font-size: .85em; color: #000;
      font-family: inherit; line-height: 1.6; white-space: nowrap;
      transition: background .15s ease, filter .15s ease;
      &:hover{ background: rgba(255, 255, 255, .78); }
      &:disabled{ opacity: .45; cursor: default; }
    }
    // кнопка внутри строки-плашки: не должна спорить с текстом, поэтому мельче и без заливки
    &__nft-btn--thin{
      margin-left: .6em; padding: .05em .55em; font-size: .8em; vertical-align: baseline;
    }
    // главное действие блока — заливка тёплым, чтобы взгляд находил его первым
    &__nft-btn--main{
      border-color: rgba(120, 78, 20, .6); font-weight: 600;
      background: linear-gradient(180deg, rgba(255, 214, 122, .95), rgba(226, 160, 44, .95));
      &:hover{ filter: brightness(1.08); background: linear-gradient(180deg, rgba(255, 224, 150, 1), rgba(236, 172, 60, 1)); }
    }
    // 🔴 ИКОНКА-КНОПКА КВАДРАТНАЯ: у «⟳» нет ширины текста, и в общем скине она выглядела обрубком.
    &__nft-btn--icon{
      width: 1.9em; padding: 0; text-align: center; font-size: 1em; line-height: 1.75;
    }
    // служебное действие: видно, но не спорит с «Обменять» — отвязка уводит фигуры из игры
    &__nft-btn--quiet{
      background: rgba(255, 255, 255, .22); border-color: rgba(0, 0, 0, .28);
      color: rgba(0, 0, 0, .68); font-size: .8em;
      &:hover{ background: rgba(160, 40, 40, .18); border-color: rgba(140, 30, 30, .5); color: #6d1a1a; }
    }
    // 🔴 ТЕКСТ В БЛОКЕ NFT ЧИТАЕТСЯ И НЕ ЛОЖИТСЯ НА УЗОР РАМКИ (жалоба оунера 2026-09-11: «поправь
    // блок НФТ-воинов, чтобы весь текст лучше читался и не залазил на рамку блока»). Было .85em
    // при `opacity: .75` — блёклый мелкий текст поверх узорной подложки, да ещё во всю ширину
    // блока, то есть вплотную к завиткам рамки. Поднимаем контраст и держим отступ от кромки.
    // 🔴 ЦВЕТ ЗАДАЁМ ЯВНО, А ПРОЗРАЧНОСТЬ ДЕРЖИМ НА ЕДИНИЦЕ (жалоба оунера 2026-09-11, третий круг:
    // «текст информационных сообщений надо сделать темнее, сейчас очень блекло смотрится на фоне
    // подложки»). Пергамент под текстом СВЕТЛЫЙ и пятнистый: `opacity` подмешивает его в каждую букву,
    // и строка выцветает ровно там, где подложка светлее. Поэтому у всех сообщений блока — сплошной
    // тёмный цвет и вес 500; приглушать разрешено только ЦВЕТОМ, а не прозрачностью.
    &__nft-hint{
      font-size: .9em; opacity: 1; line-height: 1.3; color: #3a2208; font-weight: 500;
      display: flex; align-items: center; gap: .6em; flex-wrap: wrap;
      padding: 0 .2em; overflow-wrap: anywhere;
    }
    &__nft-hint--error{ opacity: 1; color: #6b1414; }
    // Отчёт сверки владения: строки друг под другом + кнопка «понятно» (её гасит игрок, не показ).
    &__ex-row{ display: flex; align-items: center; gap: .6em; margin: .5em 0; }
    &__ex-input{ width: 8em; padding: .3em .5em; font: inherit; }
    // 🔴 ОТЧЁТ — ТЁМНЫЙ ТЕКСТ БЕЗ ПОДЛОЖКИ (решение оунера 2026-09-11: «выделять его цветом не
    // обязательно, можно было просто сделать текст потемнее»). Светлая плашка занимала полосу во всю
    // ширину блока и упиралась в узор рамки, то есть ЛЕЧИЛА читаемость ценой того же симптома.
    // 🔴 `flex-wrap: nowrap` ЗДЕСЬ НЕ КОСМЕТИКА. Базовая подсказка — флекс-РЯД С ПЕРЕНОСОМ, а
    // отчёт разворачивает её в КОЛОНКУ; при `wrap` в колонке перенос идёт ВБОК, и стоит высоте
    // упереться в потолок блока, как кнопка «ОК» уезжает во вторую колонку — то есть на правый край
    // блока, прямо поверх узорной рамки. Ровно та жалоба, ради которой блок и правился.
    // 🔴 `flex: 0 0 auto` — ВТОРАЯ ПОЛОВИНА ТОЙ ЖЕ ЖАЛОБЫ (обрезанный текст на скрине оунера
    // 2026-09-11). Блок держит ПОСТОЯННУЮ высоту, а флекс-дети по умолчанию СЖИМАЮТСЯ: отчёт ужимался
    // до 11 px при собственных 19 — у строки было видно только верхнюю половину букв, и это читалось
    // как «текст залез на графику». Сжиматься имеет право только список фигур (у него своя прокрутка).
    &__nft-hint--notice{
      opacity: 1; color: #4a2600; font-weight: 500; text-align: left;
      display: flex; flex-direction: column; flex-wrap: nowrap;
      gap: .25em; align-items: flex-start;
      flex: 0 0 auto; margin: .1em 0 .35em;
      width: 100%; box-sizing: border-box;
      // точка отсчёта для крестика в углу + место под него, чтобы строка не заезжала под кнопку
      position: relative; padding-right: 1.9em;
    }
    // сам список строк — вот он и едет, кнопка «ОК» остаётся видимой всегда; `flex: 0 0 auto`, чтобы
    // строку не сплющило до половины буквы, когда список фигур претендует на ту же высоту
    // 🔴 ПОТОЛОК КРАТЕН ВЫСОТЕ СТРОКИ, А МЕЖДУ СООБЩЕНИЯМИ НЕТ ПРОСВЕТА. Иначе прокрутка режет
    // строку ПОПОЛАМ — видна верхняя половина букв, и это неотличимо от «текст залез на графику»
    // (ровно так выглядела жалоба оунера 2026-09-11). `line-height` здесь 1.3, поэтому 2.6em —
    // это ДВЕ целые строки; любой отступ между сообщениями снова сбил бы кратность.
    &__nft-notes{
      flex: 0 0 auto; max-height: 2.6em; overflow-y: auto; scrollbar-width: thin;
      width: 100%; display: flex; flex-direction: column; gap: 0;
    }
    // 🔴 КНОПКА ОТЧЁТА ЖИВЁТ ВНУТРИ ПЛАШКИ, А НЕ У КРАЯ БЛОКА. Общий стиль строки-подсказки —
    // это флекс-РЯД с переносом, и кнопка в нём уезжала на правый край, ложась прямо на узорную
    // рамку (гард геометрии в `tools/ton-wallet-check.mjs` мерит зазор до кромки блока).
    // 🔴 КНОПКА ОТЧЁТА — В СВОЕЙ СТРОКЕ ВНУТРИ ПЛАШКИ. Общий стиль подсказки это флекс-РЯД с
    // переносом, и кнопка в нём вставала у правого края блока, ложась прямо на узорную рамку
    // (гард геометрии в `tools/ton-wallet-check.mjs` мерит зазор до кромки). Своя строка снимает
    // зависимость от того, кто и как раскладывает соседей.
    // 🔴 ЗАКРЫВАЕТ СООБЩЕНИЕ КРЕСТИК, И ОН ОДИН НА ВСЕ СТРОКИ БЛОКА (решение оунера 2026-09-11).
    // До него закрытие было только у отчёта сверки и выглядело как обычная кнопка со словом —
    // на строку с текстом это вешало второй «призыв к действию», а у остальных сообщений закрытия
    // не было вовсе. Размер держим пальцевым (не меньше 22px), иначе на телефоне в него не попасть.
    // 🔴 КРЕСТИК — ВНЕ ПОТОКА, В ПРАВОМ ВЕРХНЕМ УГЛУ СООБЩЕНИЯ. В потоке он жил ровно один снимок:
    // подсказка это флекс-РЯД С ПЕРЕНОСОМ, и на телефоне длинный текст занимает всю ширину, а
    // крестик уезжает на следующую строку — под своим сообщением, вплотную к крестику соседнего.
    // Место под него держит `--x` (padding-right), поэтому текст под кнопку не заезжает.
    &__nft-x{
      position: absolute; top: 0; right: 0;
      flex: 0 0 auto; width: 24px; height: 24px; line-height: 1;
      display: inline-flex; align-items: center; justify-content: center;
      border: 1px solid rgba(0, 0, 0, .3); border-radius: 50%;
      background: rgba(255, 255, 255, .55); color: #3a2208; font-size: .92em; cursor: pointer;
      font-family: inherit; padding: 0;
      &:hover{ background: rgba(255, 255, 255, .85); }
    }
    // сообщение с крестиком: своя точка отсчёта и место под кнопку справа
    // 🔴 Текст выравниваем ВЛЕВО: карточка профиля центрирует содержимое, и сообщение с местом под
    // крестик справа вставало бы «почти по центру» — асимметрия читается как случайный сдвиг.
    &__nft-hint--x{ position: relative; padding-right: 1.9em; text-align: left; }
    &__nft-notefoot{
      width: 100%; display: flex; align-items: center; gap: .6em;
      justify-content: flex-start; margin-top: .1em; flex: 0 0 auto;
    }
    &__nft-notecount{ font-size: .78em; opacity: 1; color: #6b563a; }
    &__nft-hint--done{ opacity: 1; color: #14521a; }
    // «обмен в пути» — ожидание, а не ошибка: янтарный, но ТЁМНЫЙ. Прежний #8a5a00 на светлом
    // пергаменте читался хуже всех строк блока — с него и началась жалоба «очень блекло».
    &__nft-hint--wait{ opacity: 1; color: #56300a; }
    // 🔴 СЕТКА, А НЕ ЛЕНТА: фигуры переносятся на новые ряды, видны ВСЕ (просьба оунера).
    // `auto-fill` сам решает, сколько колонок влезет — от ширины экрана до мини-аппа.
    // 🔴 СПИСОК ЛЕЖИТ В СВОЕЙ «ВИТРИНЕ». Без неё карточки висели прямо на пергаменте блока и
    // читались как случайные плитки: у раздела не было границы, где кончается шапка и начинается
    // коллекция. Подложка тёплая, а не тёмная — текст в блоке чёрный, на тёмной он бы пропал.
    &__nft-list{
      display: grid; gap: .55em;
      grid-template-columns: repeat(auto-fill, minmax(74px, 1fr));
      // 🔴 Карточки берут СВОЮ высоту, а не тянутся на всю строку сетки: блок раздела теперь
      // фиксированной высоты, и при `stretch` единственный ряд растягивался на все 260 px —
      // карточка выходила узкой и вдвое выше нужного.
      align-content: start; align-items: start;
      // сетка прокручивается внутри блока постоянной высоты: у владельца коллекции карточек
      // десятки, а раздел не имеет права расти и двигать всё, что под ним
      overflow-y: auto;
      scrollbar-width: thin;
      // 🔴 БЕЗ `min-height: 0` СПИСОК НЕ СЖИМАЕТСЯ И ВЫЛЕЗАЕТ ЗА БЛОК (жалоба оунера 2026-08-31:
      // «в мобильной версии список NFT уходит под границу области целиком»). Флекс-элемент по
      // умолчанию не меньше своего содержимого (`min-height: auto`), поэтому сетка из десятка
      // карточек просто выпирала вниз, а прокрутка не включалась вовсе. На узком экране шапка
      // блока занимает две строки, и остатка не хватало особенно заметно.
      flex: 1 1 auto;
      min-height: 0;
      padding: .6em;
      border-radius: 10px;
      border: 1px solid rgba(120, 82, 30, .28);
      background: rgba(120, 82, 30, .10);
      box-shadow: inset 0 2px 6px rgba(90, 60, 20, .14);
    }
    &__nft-card{
      position: relative;   // точка отсчёта для номера в углу
      box-sizing: border-box;
      // отступы и просвет тоже ужаты на пятую часть — иначе карточка становится узкой, но такой
      // же высокой, и «минус 20%» видно только по ширине (просьба оунера 2026-08-31)
      text-align: center; padding: .35em .25em .3em;
      display: flex; flex-direction: column; align-items: center; gap: .25em;
      border: 1px solid rgba(90, 60, 20, .28); border-radius: 10px;
      background: linear-gradient(180deg, rgba(255, 255, 255, .34), rgba(255, 255, 255, .14));
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, .4);
      transition: background .15s ease, transform .15s ease, box-shadow .15s ease;
      &:hover{
        background: linear-gradient(180deg, rgba(255, 255, 255, .6), rgba(255, 255, 255, .3));
        transform: translateY(-2px);
        box-shadow: 0 3px 8px rgba(40, 20, 0, .25), inset 0 1px 0 rgba(255, 255, 255, .5);
      }
      &:active{ transform: translateY(0); }
    }
    // коробка спрайта. 🔴 Метка «в строю» уходила ЗА её пределы (`-2px`) и на плотной сетке заезжала
    // на соседнюю карточку — держим внутри: карточки стоят вплотную, вылет наружу читается как брак.
    // 🔴 РАЗМЕР КАРТОЧКИ — ПРОСЬБА ОУНЕРА 2026-08-31 («сделать карточки NFT на 20% меньше»):
    // спрайт 72 → 58 px, колонка сетки 92 → 74 px. На телефоне те же −20% (52 → 42 и 66 → 53).
    &__nft-pic{ position: relative; display: block; width: 58px; height: 58px; }
    // номер предмета — в углу КАРТОЧКИ (на спрайте он закрывал фигуре голову)
    &__nft-badge{
      position: absolute; right: .25em; top: .25em; z-index: 1;
      padding: 0 .35em; border-radius: 999px;
      background: rgba(20, 14, 36, .78); color: #ffe;
      font-size: .58em; line-height: 1.6; font-variant-numeric: tabular-nums;
      pointer-events: none;
    }
    // замок «комплект запечён» — в левом верхнем углу карточки (справа номер предмета)
    // отметка «когда данные были верны» — тихая, рядом с кнопкой обновления
    &__nft-age{ font-size: .62em; opacity: 1; color: #6b563a; white-space: nowrap; align-self: center; }
    &__nft-lock{
      position: absolute; left: .25em; top: .25em; z-index: 1;
      font-size: .7em; line-height: 1;
      text-shadow: 0 0 3px #fff, 0 0 2px #fff;
      pointer-events: none;
    }
    &__nft-card{
      // карточка стала кнопкой (открывает статы) — гасим браузерные умолчания
      color: inherit; font-family: inherit; cursor: pointer;
      &--in{
        border-color: rgba(60, 140, 60, .8);
        background: linear-gradient(180deg, rgba(150, 230, 150, .42), rgba(110, 200, 110, .22));
      }
    }
    // метка «в строю» на спрайте: сразу видно, какие фигуры уже играют
    &__nft-in{
      position: absolute; left: 50%; bottom: 0; transform: translateX(-50%);
      max-width: 100%; box-sizing: border-box;
      padding: 0 .3em; border-radius: 999px;
      background: rgba(40, 110, 40, .92); color: #eaffea;
      font-size: .58em; line-height: 1.6; white-space: nowrap;
      overflow: hidden; text-overflow: ellipsis;
    }
    &__nft-img{ width: 58px; height: 58px; object-fit: contain; border-radius: 6px; }
    // заглушка вместо не загрузившейся картинки: та же коробка, вопрос по центру
    &__nft-img--none{
      display: flex; align-items: center; justify-content: center;
      border: 1px dashed rgba(0, 0, 0, .35); background: rgba(255, 255, 255, .25);
      font-size: 1.2em; color: rgba(0, 0, 0, .45);
    }
    // имя переносится максимум в две строки: полное видно в подсказке при наведении
    // 🔴 Ровно ДВЕ строки резервируются всегда (`min-height`): у одних фигур имя в одну строку, у
    // других в две, и без резерва карточки в ряду получались разной высоты — сетка выглядела рваной.
    &__nft-name{
      font-size: .62em; line-height: 1.2; width: 100%; min-height: 2.4em;
      display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;
      overflow: hidden; overflow-wrap: anywhere; opacity: 1; color: #46351c;
    }
  }


  /* Карточка NFT со статами (открывается кликом по фигуре в блоке «NFT-воины») */
  .profile__nftdlg{
    position: fixed; inset: 0; z-index: 60; display: flex; align-items: center; justify-content: center;
    background: rgba(0, 0, 0, .55); padding: 1em;
  }
  .profile__nftdlg-box{
    background: url("../assets/profile_border.webp") no-repeat, url("../assets/profiletile.webp");
    background-size: 100% 100%;
    color: #000; padding: 1.2em; border-radius: 8px;
    width: min(420px, 92vw); max-height: 86vh; overflow-y: auto; box-sizing: border-box;
  }
  .profile__nftdlg-head{ display: flex; gap: .8em; align-items: center; margin-bottom: .6em; }
  .profile__nftdlg-img{ width: 72px; height: 72px; object-fit: contain; }
  .profile__nftdlg-name{ font-weight: 600; }
  .profile__nftdlg-sub{ font-size: .8em; opacity: 1; color: #5a4526; }
  .profile__nftdlg-in{ font-size: .8em; color: #1d6b1d; }
  .profile__nftdlg-in--bench{ color: #8a6d1f; }
  .profile__nftdlg-in--baked{ color: #7a3ea1; }
  .profile__nftdlg-in--bonus{ color: #1d6b1d; font-weight: 600; }
  .profile__nftdlg-steps{ display: flex; flex-direction: column; gap: .25em; margin: .5em 0; font-size: .85em; }
  .profile__nftdlg-step{ display: flex; gap: .5em; }
  // Блок статов — копия раскладки «Настроек фигур» (`.pk__stats`): игрок сверяет две карточки
  // глазами, и другой вид читался бы как другой набор чисел.
  .profile__nftdlg-power{ margin-left: auto; font-size: .85em; white-space: nowrap; }
  .profile__nftdlg-note{ font-size: .78em; opacity: 1; color: #4a3a1e; margin-bottom: .3em; }
  .profile__nftdlg-stats{ display: flex; flex-direction: column; gap: 2px; font-size: .85em; }
  .profile__nftdlg-row--up span:last-child{ color: #1d6b1d; font-weight: 600; }
  .profile__nftdlg-row{
    display: flex; justify-content: space-between; gap: 1em;
    padding: 1px 0; border-bottom: 1px dashed rgba(0, 0, 0, .12);
  }
  .profile__nftdlg-acts{ display: flex; justify-content: flex-end; margin-top: .8em; }
  /* Панель ресурсов (самоцветы + материалы) — та же логика, что в окне Амуниции. */
  .pf__res-chip{
    display: flex; align-items: center; gap: 5px;
    padding: 3px 8px; border: 1px solid rgba(255, 255, 255, .35);
    border-radius: 999px; background: rgba(20, 14, 36, .55); color: #ffe;
    font-size: 0.85em;
  }
  .pf__gem{ width: 12px; height: 12px; transform: rotate(45deg); border-radius: 3px; border: 1px solid rgba(255, 255, 255, .55); }
  .pf__res-ico{ font-size: 0.95em; }
  // 🔴 ЧИСЛО НЕ МЕНЯЕТ ШИРИНУ ЧИПА (жалоба оунера 2026-08-31 «интерфейс прыгает»). Каркас держал
  // место, но печатал нули: с настоящими значениями чипы становились шире, ряд переносился на
  // лишнюю строку, и панель ресурсов вырастала на 30 px уже ПОСЛЕ первой отрисовки. Ширина под
  // четыре знака + моноширинные цифры: раскладка одна и та же при любом кошельке.
  .pf__res-val{ font-weight: 700; min-width: 3.4em; text-align: right; font-variant-numeric: tabular-nums; }
  .pf__res-chip--mat{ opacity: .9; }
  .pf__res-chip--gem{ position: relative; cursor: pointer; }
  .pf__gem-pop{
    position: absolute; top: calc(100% + 6px); left: 0; z-index: 30;
    min-width: 150px; padding: 8px; border-radius: 8px;
    background: #1c1533; border: 1px solid #4b3f70; box-shadow: 0 6px 20px rgba(0, 0, 0, .5);
  }
  .pf__gem-pop-title{ font-size: 0.82em; opacity: .7; margin-bottom: 6px; }
  .pf__gem-row{ display: flex; align-items: center; gap: 8px; padding: 3px 4px; border-radius: 5px; opacity: .4; }
  .pf__gem-row--has{ opacity: 1; background: rgba(182, 156, 255, .16); }
  .pf__gem-sm{ width: 10px; height: 10px; transform: rotate(45deg); border-radius: 2px; border: 1px solid rgba(255, 255, 255, .5); }
  .pf__gem-size{ flex: 1; font-size: 0.9em; }
  .pf__gem-cnt{ font-weight: 700; }


  // 🔴 РЕФЕРАЛКА — АКЦЕНТНАЯ ПЛАШКА, А НЕ ПОСЛЕДНЯЯ СТРОКА СТАТИСТИКИ (просьба оунера 2026-09-11:
  // «многие его не могут найти»). Раньше блок отличался от соседних строк только тонкой линией
  // сверху — глазу не за что зацепиться. Тёплая подложка с рамкой и заметная кнопка «Скопировать»
  // делают его отдельным элементом, при этом ВЫСОТУ карточки он по-прежнему держит каркасом.
  .profile__referral{
    margin-top: 0.9em;
    padding: 0.7em 0.8em;
    border: 1px solid rgba(150, 100, 20, .55);
    border-radius: 10px;
    background: rgba(255, 205, 110, .28);
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, .35);
    text-align: center;
    color: #000;
  }
  .profile__referral-title{ font-size: 16px; font-weight: bold; margin-bottom: 6px; }
  .profile__referral-why{ font-size: 12.5px; margin: 0 0 6px; opacity: 1; color: #3a2a10; line-height: 1.25; }
  .profile__referral-row{
    display: flex;
    justify-content: center;
    gap: 6px;
    flex-wrap: wrap;
  }
  .profile__referral-link{
    flex: 1 1 220px;
    max-width: 320px;
    padding: 6px 8px;
    border: 1px solid rgba(0,0,0,0.3);
    border-radius: 6px;
    background: transparent;
    color: #000;
    font-size: 13px;
  }
  .profile__referral-copy{
    padding: 6px 14px;
    border: 1px solid rgba(120, 80, 10, .65);
    border-radius: 6px;
    // кнопка — главное действие блока: без заливки она сливалась с полем ссылки
    background: linear-gradient(180deg, #ffd479, #e8a63a);
    color: #2b1c00;
    font-weight: 700;
    cursor: pointer;
    &:hover{ filter: brightness(1.08); }
  }
  .profile__referral-stats{ font-size: 13px; margin-top: 6px; opacity: 0.9; b{ color: #000; } }
  // до ответа сервера блок невидим, но МЕСТО ДЕРЖИТ (иначе карточка растёт и всё под ней прыгает)
  .profile__referral--pending{ visibility: hidden; }
  // то же для кнопки Telegram: признак `code_link` приезжает отдельным запросом
  .profile__logout-top--pending{ visibility: hidden; }
  .profile__btn--pending{ visibility: hidden; }
  .profile__actions{
    grid-column: 1 / -1;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 1em;
    margin-top: 0.6em;
  }
  .profile__btn{
    // скин как у кнопок «Зомби»/«Эльфы» в PvP — текстура radio.webp + ЖЁЛТЫЙ текст + hover contrast(200%)
    position: relative;
    box-sizing: border-box;
    min-width: 180px;
    padding: 0.6em 2em;
    border: none;
    background: url("../assets/radio.webp") no-repeat center;
    background-size: 100% 100%;
    color: yellow;
    font-weight: normal;
    font-size: 16px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    cursor: pointer;
    transition: ease filter 0.3s;
    &:hover{ filter: contrast(200%); }
    // «Выйти» — тот же скин, что «Амуниция» (без розового hue-rotate — оунер поймал розовый тон)
  }
  // раздел ВИДЕН, но пока закрыт обучением (мягкий гейтинг): приглушаем, hover не подсвечиваем
  .profile__btn--locked{
    filter: sepia(1) opacity(0.65);
    cursor: default;
    &:hover{ filter: sepia(1) opacity(0.65); }
  }

  @media (max-width: 720px) {
    .profile{
      // рамка ВЫШЕ (~+50%): фиксируем высоту фрейма + центрируем контент внутри него (flex-колонка)
      display: flex;
      flex-direction: column;
      justify-content: center;
      min-height: 90vh;
      // margin:auto у флекс-элемента (карточка = ребёнок .wrapper) перебивает align-items:flex-start —
      // сама рамка центрируется на экране.
      margin: auto;
      box-sizing: border-box;
      // внешняя рамка (подложка) — по 5% от краёв экрана (ширина 90vw); перебивает max-width:480px у .card-landscape
      width: 90vw;
      max-width: 90vw;
      // 🔴 ГЛАВНЫЙ ФИКС: у card-landscape ТОЛСТАЯ узорная рамка (особенно углы). Раньше здесь стоял
      // padding:0 22px → ВЕРТИКАЛЬНЫЙ паддинг был 0 → нижняя кнопка «Выйти» вылезала за нижнюю кромку рамки.
      // Даём щедрый отступ сверху/снизу (30/40px), чтобы контент не заходил на рамку/углы.
      padding: 30px 22px 40px;
      // блоки рейтинг/энергия/имя/connect-wallet — во всю ширину рамки (как статистика ниже)
      &__rating, &__energy, &__username, &__wallet, &__logout-top{
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
      }
      // ряд кнопок — на всю ширину рамки (сами кнопки — 70vw, см. ниже)
      &__actions{
        max-width: 100%;
        margin-left: auto;
        margin-right: auto;
      }
      &__face{
        // на всю ширину рамки — иначе имя/wallet внутри (width:100% от face) оставались узкими
        margin: 0 auto 0.6em;
        width: 100%;
        max-width: 100%;
      }
      &__photo{
        height: 104px;
        width: 104px;
        margin: 0 auto;
        // на мобилке НЕ поднимаем фото (desktop top:-2em задирал бы его на верхнюю рамку)
        top: 0;
      }
      &__rating, &__energy{
        padding: 0.55em 12%;  // те же проценты, что на десктопе: текст внутри поля спрайта
        margin-bottom: 0.55em;
        font-size: 0.85em;
        justify-content: center;
        gap: 1em;
      }
      &__username, &__wallet{
        text-align: center;
      }
      // на телефоне шаг между табличками мельче — задаём его тем же одним `gap`, а не отступами
      &__face{ gap: 0.5em; }
      &__resources{
        margin-bottom: 0.6em;
        // 🔴 ВСЕ ГРУППЫ РЕСУРСОВ ВЫРАВНЕНЫ ПО ЛЕВОМУ КРАЮ (жалоба оунера 2026-08-31: «блок с
        // материалами центруется, а остальные блоки выровнены по левому краю»). Группы разной
        // ширины: самоцветы и бусты занимают строку целиком и выглядят прижатыми влево, а короткая
        // строка материалов при `center` вставала посередине — ряды казались разъехавшимися.
        justify-content: flex-start;
      }
      &__statistic{
        margin-bottom: 0.6em;
        // верт. паддинг = межстрочный интервал (line-height 1.55em) — текст не липнет к узорной рамке
        padding: 1.55em 1em;
        line-height: 1.55;
      }
      &__nft{
        margin-bottom: 0.6em;
        // 🔴 ВЫСОТА С ЗАПАСОМ ПОД ДВА РЯДА КАРТОЧЕК (жалоба оунера 2026-08-31: «в мобильной версии
        // совсем не видно список NFT»). Шапка блока на телефоне идёт ТРЕМЯ строками (название,
        // баланс с «Обменять», служебные кнопки) и съедает ~140 px: при высоте 240 списку
        // оставалось 80 px — не помещался даже один ряд, и казалось, что фигур нет вовсе.
        // Блок по-прежнему ПОСТОЯНЕН по высоте (иначе приход `/ton/assets` снова двигал бы экран).
        // 🔴 330 → 380 (просьба оунера 2026-09-11 «расширить область для NFT»): шапка в три строки
        // плюс отчёт съедали столько, что на список оставалось меньше одного ряда карточек. Страница
        // профиля на телефоне и так прокручивается — рост высоты тут дешевле, чем невидимый список.
        height: 380px;
        // 🔴 Сверху отступ БОЛЬШЕ бокового: узор рамки `profile_border.webp` толще именно по
        // горизонтальным кромкам, и при равном отступе заголовок «NFT-воины» ложился прямо на него.
        // 🔴 Боковой отступ поднят с 1.1em (жалоба 2026-09-11 «текст залазит на рамку»): длинная
        // строка отчёта на телефоне доходила до самой кромки и наезжала на завиток узора.
        padding: 1.5em 1.4em 1.3em;
      }
      // на телефоне одно сообщение отчёта переносится на три строки — потолок тоже кратен строке
      &__nft-notes{ max-height: 3.9em; }
      // на телефоне карточки мельче — в ряд влезает 4 штуки вместо двух
      &__nft-list{ grid-template-columns: repeat(auto-fill, minmax(53px, 1fr)); }
      &__nft-pic, &__nft-img{ width: 42px; height: 42px; }
      // шапка в две строки: баланс с семизначным числом не оставляет места кнопкам
      &__nft-head{ flex-direction: column; align-items: flex-start; gap: .4em; }
      // 🔴 На узком экране группы переносятся по строкам и выравниваются ПО ЛЕВОМУ КРАЮ. При
      // `space-between` перенос растаскивал баланс и «Обменять» к противоположным краям экрана, а
      // «Отвязать» оказывалась в неожиданном месте — на таче это прямой путь к промаху.
      &__nft-tools{ width: 100%; justify-content: flex-start; gap: .45em .8em; }
      &__actions{
        flex-direction: column;
        align-items: center;
        gap: 0.55em;
        margin-top: 0.2em;
      }
      &__btn{
        // кнопки — отступ 15% от краёв экрана (ширина 70vw), центрированы
        width: 70vw;
        max-width: 70vw;
        min-width: 0;
      }
    }
  }
</style>
